import React, { useState, useEffect } from "react";
import {
  Table,
  Modal,
  Steps,
  Form,
  Input,
  Progress,
  Tag,
  Tooltip,
  Space,
  Spin,
  Button,
  Row,
  Col,
  InputNumber,
  Typography,
  Divider,
  Select,
  message,
  Popconfirm,
  DatePicker,
} from "antd";
import {
  EditOutlined,
  SearchOutlined,
  MenuFoldOutlined,
  FileSearchOutlined,
  EyeOutlined,
  MenuUnfoldOutlined,
  PlusOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import Header166 from "../../../components/header/header";
import "./PlanesCompras.css";

import { getParticipantesSostenibilidad } from "../../../services/financiero/plandecompras/getPlanesSostenibilidad";
import { getPlanesCompraSostenibilidad } from "../../../services/financiero/plandecompras/planesdecomprasostenibilidad";
import { registrarPlanCompraSostenibilidad } from "../../../services/financiero/plandecompras/setPlandeComprasSostenibilidad";
import { actualizarPlanCompraSostenibilidad } from "../../../services/financiero/plandecompras/updatePlandecomprasSostenibilidad";

import { getProductos } from "../../../services/financiero/productos/getProductos";

import FormatoPlanComprasSostenibilidad from "./FormatoPlanComprasSostenibilidad"; // 📌 Importa el componente

import { useSelector } from "react-redux";
import { selectAppPermissions } from "../../../store/auth/selectors";

import dayjs from "dayjs";

const { Title } = Typography;
const { Step } = Steps;

const factores = [
  {
    factor: "Factor 1. Acompañamiento y fortalecimiento técnico y financiero",
    subfactores: [
      "El proyecto productivo funciona bajo un modelo técnico que le permite obtener resultados productivos esperados en la formulación del proyecto productivo en términos de oportunidad y calidad del producto y/o servicios ofrecidos.",
      "El proyecto productivo cuenta con personal capacitado para el manejo adecuado del modelo productivo y financiero",
      "La capacidad instalada en términos de activos productivos (Ej: herramientas, equipos, maquinaria, instalaciones físicas, inventarios, material vegetal y animal, principalmente) es suficiente para el desarrollo del modelo técnico productivo del proyecto productivo",
      "Las decisiones financieras del proyecto productivo se toman con base en herramientas e informes contables y administrativos.",
      "Los ingresos de la actividad productiva permiten cubrir los costos operativos, reinvertir en la producción y mantener el capital de trabajo (punto de equilibrio)",
    ],
  },
  {
    factor: "Factor 2. Fortalecimiento organizativo y asociativo",
    subfactores: [
      "La forma asociativa o el colectivo de trabajo cumple las obligaciones tributarias y administrativas.",
      "Las actividades programadas en el PRE PPC se desarrollan bajo una estructura de coordinación y gerencia, orientada por la forma asociativa",
      "Las personas vinculadas al proyecto productivo conocen del desarrollo del mismo y participan en la toma de decisiones y la gestión de acciones.",
      "La forma asociativa o el colectivo de trabajo aplica mecanismos para el trámite asertivo de conflictos internos.",
    ],
  },
  {
    factor:
      "Factor 3. Acompañamiento y fortalecimiento a procesos de mercadeo y comercialización",
    subfactores: [
      "El proyecto productivo comercializa la totalidad de sus bienes/servicios producidos.",
      "El proyecto productivo cuenta e implementa una estrategia de mercadeo y comercialización adecuada para cumplir sus objetivos.",
      "En opinión de los clientes el proyecto productivo cumple con los requerimientos de: precio, cantidad, calidad y oportunidad de entrega.",
    ],
  },
  {
    factor:
      "Factor 4. Acompañamiento y gestión para la articulación e incidencia territorial ",
    subfactores: [
      "Las relaciones entre las y los participantes, las comunidades aledañas y las organizaciones con incidencia territorial se manifiestan en acciones de desarrollo social, productivo y construcción de agendas territoriales.",
      "El proyecto productivo y sus gestores han logrado articularse con actores, planes, programas y proyectos público/privados/cooperación internacional en el marco de la planeación local, regional y nacional.",
      "El proyecto productivo y las comunidades se articulan entre si a las cadenas de valor territoriales de forma directa o indirecta (ej: empleos, proveeduría, producción, comercialización).",
      "El proyecto productivo se articula con redes productivas que aportan a su sostenibilidad (ej: Coordinadora de Federaciones, Federaciones, Mesa Nacional de Café, de Piscicultura, Red Renace, otros PPC, proyecto confederativo, etc) ",
      "El proyecto productivo tiene prácticas adecuadas con la vocación ambiental, productiva y sociocultural del territorio. ",
      "La cohesión y fortalecimiento interno del proyecto productivo le permite asumirse como poder movilizador en el territorio.",
    ],
  },
  {
    factor:
      "Factor 5. Implementación de los enfoques de género, étnico y diferenciales ",
    subfactores: [
      "Los procesos productivos y organizativos desarrollan acciones para incluir la perspectiva, intereses, motivaciones, necesidades y facilitar la participación de las personas que se autoreconocen como parte de grupos étnicos, LGBTIQ+, personas con discapacidad, jóvenes y/o adultos mayores.",
      "La forma asociativa o el colectivo de trabajo motiva/promueve la participación efectiva y el liderazgo de las mujeres en los procesos productivos y de dirección del proyecto productivo y de la misma forma asociativa.   * Participación efectiva: vinculación a espacios decisorios y productivos para garantizar la vinculación de las mujeres en los procesos del proyecto productivo.",
      "Se han previsto o incorporado acciones que propenden por la autonomía económica de las mujeres, el fortalecimiento de espacios y los mecanismos de cuidado.",
    ],
  },
  {
    factor: "Factor 6. Tierras y predios urbanos ",
    subfactores: [
      "El predio en donde se desarrolla el proyecto productivo está ubicado en una zona que permite la actividad productiva de acuerdo con los requerimientos de uso del suelo y las determinantes ambientales.",
      "El predio en donde se desarrolla el proyecto productivo se ajusta a la vocación, el uso del suelo y el ordenamiento real del territorio",
      "El predio donde se implementa el proyecto productivo cumple con las condiciones técnicas requeridas para el funcionamiento del modelo productivo (Servicios públicos, infraestructura productiva, área, etc.)",
      "Las condiciones de tenencia del predio donde se ubica el proyecto productivo brindan seguridad jurídica para su adecuado desarrollo y cumplimiento de los objetivos productivos y financieros.",
      "La ubicación del predio donde actualmente se implementa el proyecto productivo facilita el proceso de comercialización y provisión para la competitividad",
    ],
  },
  {
    factor: "Factor 7. Seguridad",
    subfactores: [
      "El proyecto productivo puede seguir siendo implementado en el lugar donde se ubica bajo las condiciones actuales de seguridad",
      "La forma asociativa o el colectivo de trabajo cuenta con conocimiento de las rutas de atención en riesgos de seguridad y violación de derechos humanos",
    ],
  },
  {
    factor: "Factor 8. Ambiental ",
    subfactores: [
      "El proyecto productivo cumple con las leyes, regulaciones y permisos ambientales aplicables.",
      "El proyecto productivo implementa acciones en relación a la conservación, mitigación, gestión del riesgo y/o compensación ambiental (acciones ambientales).  ",
      "El proyecto productivo realiza acciones de reconversión productiva (transformar el modelo productivo).",
      "El proyecto productivo corresponde a la vocación productiva y ecológica del territorio donde se desarrolla",
    ],
  },
];

const PlanesCompras = () => {
  const [planes, setPlanes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPlan, setCurrentPlan] = useState(null);
  const [currentStep, setCurrentStep] = useState(0); // Control del paso actual
  const [stepsVisible, setStepsVisible] = useState(true); // Controla la visibilidad del panel de Steps
  const toggleSteps = () => setStepsVisible(!stepsVisible);
  const [participantes, setParticipantes] = useState([]);
  const [productosSostenibilidad, setProductosSostenibilidad] = useState([]);
  const [productosMap, setProductosMap] = useState({});

  const usernameFromState = useSelector((state) => state.auth.user);

  // Estado para controlar el modal y el mensaje de error
  const [isExceeding, setIsExceeding] = useState(false); // Detecta si el presupuesto fue excedido
  const [proyectado, setProyectado] = useState(0); // Calcula el valor proyectado
  const [isModalVisible, setIsModalVisible] = useState(false); // Controla la visibilidad del modal de advertencia
  const [presupuestoasignado, setPresupuestoasignado] = useState([0]);

  const [isModalPreviewOpen, setIsModalPreviewOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const [initialData, setInitialData] = useState([]);

  const [searchText, setSearchText] = useState("");
  const [filteredPlanes, setFilteredPlanes] = useState([]); // Datos filtrados

  const [existingPlanCodes, setExistingPlanCodes] = useState([]); // ← aquí

  const [subtotals, setSubtotals] = useState({
    infraestructura: 0,
    activos: 0,
    herramientas: 0,
    insumos: 0,
    gastos: 0,
    contrapartida: 0,
  });

  const [selectedProductDetails, setSelectedProductDetails] = useState(null);
  const [isModalVisibleP, setIsModalVisibleP] = useState(false);

  //Control de Permisos
  const appName = "planesdecomprasostenibilidad";
  const permissions = useSelector((state) =>
    selectAppPermissions(state, appName)
  );
  const permissionDelete = permissions.priv_delete === "Y";
  const permissionUpdate = permissions.priv_update === "Y";
  const permissionInsert = permissions.priv_insert === "Y";
  const permissionExport = permissions.priv_export === "Y";

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  // Función para mostrar el modal con los detalles del producto
  const showProductDetails = (product) => {
    setSelectedProductDetails(product);
    setIsModalVisibleP(true);
  };

  // Función para cerrar el modal
  const handleCloseModalP = () => {
    setIsModalVisibleP(false);
  };

  // 📌 Función para abrir el modal con los detalles del plan seleccionado
  const handlePreview = (plan) => {
    setSelectedPlan(plan);
    setIsModalPreviewOpen(true);
  };

  // 📌 Función para cerrar el modal
  const handleClosePreview = () => {
    setIsModalPreviewOpen(false);
    setSelectedPlan(null);
  };

  // Calcula el valor proyectado cada vez que los subtotales cambien
  useEffect(() => {
    const totalProyectado = Object.values(subtotals).reduce(
      (acc, val) => acc + val,
      0
    );
    if (totalProyectado > presupuestoasignado) {
      setIsExceeding(true);
      handleOpenModal();
    } else {
      setIsExceeding(false);
    }
  }, [subtotals, presupuestoasignado]);

  // Función para abrir el modal cuando se detecta un exceso
  const handleOpenModal = () => {
    setIsModalVisible(true);
  };

  // Función para cerrar el modal sin cambiar el estado de `isExceeding`
  const handleCloseModal = () => {
    setIsModalVisible(false); // Cierra el modal, pero no cambia isExceeding
  };

  const [form] = Form.useForm();

  const steps = [
    { title: "Proyecto" },
    { title: "A. Infraestructura" },
    { title: "B. Activos Productivos y equipos" },
    { title: "C. Herramientas y Mobiliario" },
    { title: "D. Insumos" },
    { title: "E. Gastos Operativos" },
    { title: "F. Contrapartida" },
    { title: "Concepto de la inversión" },
  ];

  // Función para cargar los datos desde el servicio
  // 1. Fetch planes y extrae códigos únicos
  const fetchPlanes = async () => {
    try {
      const response = await getPlanesCompraSostenibilidad();

      if (response.status === 200) {
        const processedData = response.data.map((item) => ({
          ...item,
          dataItems:
            typeof item.dataItems === "string"
              ? JSON.parse(item.dataItems)
              : item.dataItems,
          conceptoInversion:
            typeof item.conceptoInversion === "string"
              ? JSON.parse(item.conceptoInversion)
              : item.conceptoInversion,
        }));

        setPlanes(processedData);

        // 1.a extraer códigos únicos
        const codes = Array.from(
          new Set(processedData.map((p) => p.codigoInterno))
        );
        setExistingPlanCodes(codes);
      } else {
        console.error("Error al obtener los planes:", response.message);
      }
    } catch (error) {
      console.error("❌ Error al cargar los planes:", error);
    }
  };

  useEffect(() => {
    fetchPlanes();
  }, []);

  // Cargar los participantes desde el servicio
  const fetchParticipantes = async () => {
    setLoading(true);
    try {
      // Llamar al servicio para obtener los participantes
      const response = await getParticipantesSostenibilidad();

      // Validar que el servicio respondió correctamente
      if (response && response.status === 200) {
        // Mapear los datos al formato requerido por Ant Design Select
        const options = response.data.map((item) => ({
          value: item.codigoInterno, // Utiliza el campo "codigoInterno" para el valor
          label: `${item.codigoInterno} - ${item.nombre} - ${item.implementador}`, // Combina "codigoInterno" y "nombre" para mostrar
        }));
        setParticipantes(options); // Establecer las opciones en el estado
      } else {
        console.error("Error al cargar los participantes:", response.message);
      }
    } catch (error) {
      console.error("Error al cargar los participantes:", error);
    } finally {
      setLoading(false);
    }
  };

  // Cargar los fetchProductosSostenibilidad desde el servicio
  const fetchProductosSostenibilidad = async () => {
    setLoading(true);
    try {
      const response = await getProductos();
      if (response) {
        const options = response.map((item) => ({
          value: item.oid,
          label: `${item.codigo} - ${item.nombre_producto}`,
          oidUnidadeMedida: item.oid_unidad_medida,
        }));

        const map = response.reduce((acc, item) => {
          acc[item.oid] = item; // Guardar todos los datos del producto
          return acc;
        }, {});

        setProductosSostenibilidad(options);
        setProductosMap(map);
      } else {
        console.error("Error al cargar los productos:", response.message);
      }
    } catch (error) {
      console.error("Error al cargar los productos:", error);
    } finally {
      setLoading(false);
    }
  };

  // Llama a fetchParticipantes al montar el componente
  useEffect(() => {
    fetchParticipantes();
  }, []);

  useEffect(() => {
    fetchPlanes();
  }, []);

  const handleEdit = (record) => {
    if (!record || !record.oid) return;
    setCurrentPlan(record);
    setIsModalOpen(true);
    setCurrentStep(0);
    fetchProductosSostenibilidad();
    setInitialData(JSON.stringify(record));

    // 🔹 Clonación profunda manual segura
    const deepClonePlan = (plan) => {
      return {
        ...plan,
        dataItems: plan.dataItems.map((section) => ({
          ...section,
          items: section.items.map((item) => ({ ...item })),
        })),
        conceptoInversion: plan.conceptoInversion.map((item) => ({ ...item })),
      };
    };

    // 🔹 Creamos copia segura
    const formattedRecord = deepClonePlan(record);

    // 🔹 Procesamos campos
    formattedRecord.codigoInterno = formattedRecord.codigoInterno
      ? formattedRecord.codigoInterno.split(",")
      : [];

    // 🔹 Normalizamos items
    formattedRecord.dataItems.forEach((section) => {
      section.items = (section.items || []).map((item) => ({
        oid: item.oid ?? 0,
        codigo: item.codigo ?? "",
        oid_categoria: item.oid_categoria ?? 0,
        nombreCategoria: item.nombreCategoria ?? "No asignado",
        nombre_producto: item.nombre_producto ?? "",
        descripcion_producto: item.descripcion_producto ?? "",
        oid_unidad_medida: item.oid_unidad_medida ?? 0,
        nombreUnidadMedida: item.nombreUnidadMedida ?? "",
        precio_unitarioPesos: item.precio_unitarioPesos
          ? parseFloat(item.precio_unitarioPesos)
          : 0,
        precio_usd: item.precio_usd ? parseFloat(item.precio_usd) : 0,
        clasificacion: item.clasificacion ?? "",
        simbolo_proyecto: item.simbolo_proyecto ?? "",
        oid_fin_tipoProducto: item.oid_fin_tipoProducto ?? 0,
        nombreTipoProducto: item.nombreTipoProducto ?? "",
        unidad_tecnica: item.unidad_tecnica ?? "",
        estado: item.estado ?? "",
        descripcion: item.oidProducto ?? item.oid ?? 0,
        recurso: item.recurso ?? "",
        cantidad: item.cantidad ?? 0,
        unidad: item.nombreUnidadMedida ?? "",
        oid_unidad_medida: item.oid_unidad_medida ?? 0,
        valorUnitario: Number(
          parseFloat(
            item.valorUnitario ?? item.precio_unitarioPesos ?? 0
          ).toFixed(2)
        ),
        valorTotal: Number(parseFloat(item.valorTotal ?? 0).toFixed(2)),
        factor: item.factor ?? "",
        subfactor: item.subfactor ?? "",
      }));
    });

    // 🔹 Configuración para el formulario
    const sectionsMap = {
      "A. Infraestructura": "infraestructura",
      "B. Activos Productivos y equipos": "activos",
      "C. Herramientas y Mobiliario": "herramientas",
      "D. Insumos": "insumos",
      "E. Gastos Operativos": "gastos",
      "F. Contrapartida": "contrapartida",
    };

    const initialValues = {
      codigoInterno: formattedRecord.codigoInterno,
      infraestructura: [],
      activos: [],
      herramientas: [],
      insumos: [],
      gastos: [],
      contrapartida: [],
    };

    formattedRecord.dataItems.forEach((section) => {
      const key = sectionsMap[section.title];
      if (key) {
        initialValues[key] = section.items;
      }
    });

    // 🔹 Seteamos los valores al formulario
    form.setFieldsValue(initialValues);

    // 🔹 Calculamos presupuesto asignado
    const cods = Array.isArray(initialValues.codigoInterno)
      ? initialValues.codigoInterno
      : [initialValues.codigoInterno];

    setPresupuestoasignado(cods.length * 400_000_000);

    // 🔹 Calculamos subtotales y total proyectado
    const newSubtotals = {
      infraestructura: 0,
      activos: 0,
      herramientas: 0,
      insumos: 0,
      gastos: 0,
      contrapartida: 0,
    };

    formattedRecord.conceptoInversion.forEach((item) => {
      switch (item.concepto) {
        case "A. Infraestructura":
          newSubtotals.infraestructura = item.valor;
          break;
        case "B. Activos Productivos y equipos":
          newSubtotals.activos = item.valor;
          break;
        case "C. Herramientas y Mobiliario":
          newSubtotals.herramientas = item.valor;
          break;
        case "D. Insumos":
          newSubtotals.insumos = item.valor;
          break;
        case "E. Gastos Operativos":
          newSubtotals.gastos = item.valor;
          break;
        case "F. Contrapartida":
          newSubtotals.contrapartida = item.valor;
          break;
      }
    });

    setSubtotals(newSubtotals);
    setProyectado(Object.values(newSubtotals).reduce((a, b) => a + b, 0));
  };

  const handleCreate = () => {
    setCurrentPlan(null);
    setIsModalOpen(true);
    setCurrentStep(0); // Reinicia al primer paso
    setPresupuestoasignado(0); // Reinicia el presupuesto
    // Llama a fetchParticipantes al montar el modal
    fetchProductosSostenibilidad();
    form.resetFields();
    setSubtotals({
      infraestructura: 0,
      activos: 0,
      herramientas: 0,
      insumos: 0,
      gastos: 0,
      contrapartida: 0,
    }); // Restablecer subtotales a cero
  };

  // 📌 Calcula la sumatoria de cada concepto
  const totalizarConceptos = (data) => {
    const totals = {
      infraestructura: 0,
      activos: 0,
      herramientas: 0,
      insumos: 0,
      gastos: 0,
      contrapartida: 0,
      total: 0,
    };

    data.forEach((plan) => {
      plan.conceptoInversion.forEach((concepto) => {
        switch (concepto.concepto) {
          case "A. Infraestructura":
            totals.infraestructura += concepto.valor;
            break;
          case "B. Activos Productivos y equipos":
            totals.activos += concepto.valor;
            break;
          case "C. Herramientas y Mobiliario":
            totals.herramientas += concepto.valor;
            break;
          case "D. Insumos":
            totals.insumos += concepto.valor;
            break;
          case "E. Gastos Operativos":
            totals.gastos += concepto.valor;
            break;
          case "F. Contrapartida":
            totals.contrapartida += concepto.valor;
            break;
          case "TOTAL PROYECTO":
            totals.total += concepto.valor;
            break;
          default:
            break;
        }
      });
    });

    return totals;
  };

  // 📌 Obtiene los totales calculados
  const totals = totalizarConceptos(planes);

  const columns = [
    {
      title: "Acciones",
      key: "acciones",
      align: "center",
      width: 150,
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            icon={<EyeOutlined />}
            onClick={() => handlePreview(record)}
          />
          {permissionUpdate && (
            <Button
              type="primary"
              icon={<EditOutlined />}
              onClick={() => handleEdit(record)}
            />
          )}

          {permissionExport && (
            <FormatoPlanComprasSostenibilidad plan={record} />
          )}
        </Space>
      ),
    },

    {
      title: "Código PRE",
      key: "codPre",
      dataIndex: "dataJson",
      align: "center",
      width: 150,
      render: (dataJson) => {
        if (!Array.isArray(dataJson) || dataJson.length === 0) return "-";
        // Extraer todos los codPre y unirlos con coma
        const listaCodPre = dataJson
          .map((item) => item.codPre)
          .filter(Boolean) // descartamos strings vacíos, en caso de que existan
          .join(", ");
        return listaCodPre || "-";
      },
    },
    {
      title: "Implementador",
      key: "implementador",
      dataIndex: "dataJson",
      align: "center",
      width: 200,
      render: (dataJson) => {
        if (!Array.isArray(dataJson) || dataJson.length === 0) return "-";
        // Extraer todos los implementador y unirlos con coma
        const listaImpl = dataJson
          .map((item) => item.implementador)
          .filter(Boolean)
          .join(", ");
        return listaImpl || "-";
      },
    },

    {
      title: "Código Interno",
      dataIndex: "codigoInterno",
      key: "codigoInterno",
      align: "center",
      width: 150, // 🔹 Define un ancho fijo
      render: (text) => {
        // Si el texto tiene más de 10 caracteres, lo recorta y añade '...'
        const isLong = text.length > 10;
        const displayText = isLong ? `${text.substring(0, 10)}...` : text;

        return (
          <Tooltip title={text}>
            <span>{displayText}</span>
          </Tooltip>
        );
      },
    },

    {
      title: "Total Proyecto",
      dataIndex: "conceptoInversion",
      key: "total",
      align: "right",
      width: 150,
      render: (conceptoInversion) => {
        const concepto = conceptoInversion?.find(
          (c) => c.concepto === "TOTAL PROYECTO"
        );
        return concepto
          ? concepto.valor.toLocaleString("es-CO", {
            style: "currency",
            currency: "COP",
          })
          : "-";
      },
    },
    {
      title: "Usuario",
      dataIndex: "user",
      key: "user",
      width: 100,
    },
    {
      title: "A. Infraestructura",
      dataIndex: "conceptoInversion",
      key: "infraestructura",
      align: "right",
      width: 150,

      render: (conceptoInversion) => {
        const concepto = conceptoInversion?.find(
          (c) => c.concepto === "A. Infraestructura"
        );
        return concepto
          ? concepto.valor.toLocaleString("es-CO", {
            style: "currency",
            currency: "COP",
          })
          : "-";
      },
    },
    {
      title: "B. Activos Productivos y equipos",
      dataIndex: "conceptoInversion",
      key: "activos",
      align: "right",
      width: 200,

      render: (conceptoInversion) => {
        const concepto = conceptoInversion?.find(
          (c) => c.concepto === "B. Activos Productivos y equipos"
        );
        return concepto
          ? concepto.valor.toLocaleString("es-CO", {
            style: "currency",
            currency: "COP",
          })
          : "-";
      },
    },
    {
      title: "C. Herramientas y Mobiliario",
      dataIndex: "conceptoInversion",
      key: "herramientas",
      align: "right",
      width: 150,

      render: (conceptoInversion) => {
        const concepto = conceptoInversion?.find(
          (c) => c.concepto === "C. Herramientas y Mobiliario"
        );
        return concepto
          ? concepto.valor.toLocaleString("es-CO", {
            style: "currency",
            currency: "COP",
          })
          : "-";
      },
    },
    {
      title: "D. Insumos",
      dataIndex: "conceptoInversion",
      key: "insumos",
      align: "right",
      width: 150,

      render: (conceptoInversion) => {
        const concepto = conceptoInversion?.find(
          (c) => c.concepto === "D. Insumos"
        );
        return concepto
          ? concepto.valor.toLocaleString("es-CO", {
            style: "currency",
            currency: "COP",
          })
          : "-";
      },
    },
    {
      title: "E. Gastos Operativos",
      dataIndex: "conceptoInversion",
      key: "gastos",
      align: "right",
      width: 150,

      render: (conceptoInversion) => {
        const concepto = conceptoInversion?.find(
          (c) => c.concepto === "E. Gastos Operativos"
        );
        return concepto
          ? concepto.valor.toLocaleString("es-CO", {
            style: "currency",
            currency: "COP",
          })
          : "-";
      },
    },
    {
      title: "F. Contrapartida",
      dataIndex: "conceptoInversion",
      key: "contrapartida",
      align: "right",
      width: 150,

      render: (conceptoInversion) => {
        const concepto = conceptoInversion?.find(
          (c) => c.concepto === "F. Contrapartida"
        );
        return concepto
          ? concepto.valor.toLocaleString("es-CO", {
            style: "currency",
            currency: "COP",
          })
          : "-";
      },
    },

    {
      title: "Fecha Creación",
      dataIndex: "fecha_creacion",
      key: "fecha_creacion",
      align: "center",
      width: 150,

      render: (fecha) =>
        new Date(fecha).toLocaleDateString("es-CO", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }),
    },
    {
      title: "Última Actualización",
      dataIndex: "fecha_actualizacion",
      key: "fecha_actualizacion",
      align: "center",
      width: 150,

      render: (fecha) =>
        new Date(fecha).toLocaleDateString("es-CO", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }),
    },
  ];

  const next = () => {
    if (currentStep === 0) {
      form
        .validateFields(["codigoInterno"])
        .then(() => {
          setCurrentStep((prev) => prev + 1);
        })
        .catch((errorInfo) => {
          console.error("Error en los campos del paso 0:", errorInfo);
        });
    } else if (currentStep === 1) {
      if (validateFormListFields("infraestructura")) {
        setCurrentStep((prev) => prev + 1);
      }
    } else if (currentStep === 2) {
      if (validateFormListFields("activos")) {
        setCurrentStep((prev) => prev + 1);
      }
    } else if (currentStep === 3) {
      if (validateFormListFields("herramientas")) {
        setCurrentStep((prev) => prev + 1);
      }
    } else if (currentStep === 4) {
      if (validateFormListFields("insumos")) {
        setCurrentStep((prev) => prev + 1);
      }
    } else if (currentStep === 5) {
      if (validateFormListFields("gastos")) {
        setCurrentStep((prev) => prev + 1);
      }
    } else if (currentStep === 6) {
      if (validateFormListFields("contrapartida")) {
        setCurrentStep((prev) => prev + 1);
      }
    } else {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const prev = () => {
    if (currentStep === 6 && !validateFormListFields("contrapartida")) {
      message.error(
        "Complete los campos de Contrapartida antes de retroceder."
      );
      return;
    } else if (currentStep === 5 && !validateFormListFields("gastos")) {
      message.error("Complete los campos de Gastos antes de retroceder.");
      return;
    } else if (currentStep === 4 && !validateFormListFields("insumos")) {
      message.error("Complete los campos de Insumos antes de retroceder.");
      return;
    } else if (currentStep === 3 && !validateFormListFields("herramientas")) {
      message.error("Complete los campos de Herramientas antes de retroceder.");
      return;
    } else if (currentStep === 2 && !validateFormListFields("activos")) {
      message.error(
        "Complete los campos de Activos Productivos antes de retroceder."
      );
      return;
    } else if (
      currentStep === 1 &&
      !validateFormListFields("infraestructura")
    ) {
      message.error(
        "Complete los campos de Infraestructura antes de retroceder."
      );
      return;
    }

    // Solo retrocede si no hubo errores en los pasos anteriores
    setCurrentStep((prev) => prev - 1);
  };

  const handleStepChange = (nextStep) => {
    // Valida los campos según el paso actual

    if (nextStep === steps.length - 1 && isExceeding) {
      // Previene avanzar al último paso si hay error
      return;
    }

    setStepsVisible(false); // Asegura que los pasos estén visibles al cambiar
    if (currentStep === 0) {
      form
        .validateFields(["codigoInterno"])
        .then(() => {
          setCurrentStep(nextStep);
        })
        .catch(() => {
          message.error(
            "Debe diligenciar todos los campos requeridos en el paso 0 antes de continuar."
          );
        });
    } else if (currentStep === 1) {
      if (validateFormListFields("infraestructura")) {
        setCurrentStep(nextStep);
      }
    } else if (currentStep === 2) {
      if (validateFormListFields("activos")) {
        setCurrentStep(nextStep);
      }
    } else if (currentStep === 3) {
      if (validateFormListFields("herramientas")) {
        setCurrentStep(nextStep);
      }
    } else if (currentStep === 4) {
      if (validateFormListFields("insumos")) {
        setCurrentStep(nextStep);
      }
    } else if (currentStep === 5) {
      if (validateFormListFields("gastos")) {
        setCurrentStep(nextStep);
      }
    } else if (currentStep === 6) {
      if (validateFormListFields("contrapartida")) {
        setCurrentStep(nextStep);
      }
    } else {
      // Si no hay validaciones específicas para este paso, permite el cambio
      setCurrentStep(nextStep);
    }
  };

  const renderProgressBar = (value) => {
    const porcentaje =
      totalProyecto > 0 ? ((value / totalProyecto) * 100).toFixed(2) : 0;
    return (
      <Progress
        percent={porcentaje}
        strokeColor="#1890ff"
        showInfo
        format={(percent) => `${percent}%`}
        status="active"
        style={{ width: "150px", marginLeft: "10px" }}
      />
    );
  };

  const handleCancel = () => {
    Modal.confirm({
      title: "¿Está segur@ de que desea cerrar?",
      content:
        "Si cierra esta ventana, la información ingresada no se guardará.",
      okText: "Sí, cerrar",
      cancelText: "No",
      onOk: () => {
        setCurrentPlan(null);
        setSelectedProductDetails(null);
        setInitialData([]);
        form.resetFields(); // Reinicia el formulario
        setIsModalOpen(false);
      }, // Cierra el modal
    });
  };

  const validateFormListFields = (fieldName) => {
    const fieldValues = form.getFieldValue(fieldName);
    let isValid = true;

    if (!Array.isArray(fieldValues)) {
      return true;
    }

    // Campos que deben existir
    const requiredFields = [
      "descripcion",
      "recurso",
      "unidad",
      "cantidad",
      "valorUnitario",
    ];

    // Para detectar duplicados por OID
    const descripcionSet = new Set();

    fieldValues.forEach((item, index) => {
      if (!item) {
        isValid = false;
        return;
      }

      // Valida cada campo requerido
      requiredFields.forEach((field) => {
        if (
          item[field] === undefined ||
          item[field] === null ||
          item[field] === ""
        ) {
          isValid = false;
          form.validateFields([[fieldName, index, field]]);
        }
      });

      // Validación de duplicados usando item.descripcion (el OID)
      if (item.descripcion != null) {
        const key = item.descripcion.toString();

        const selectedProduct = productosMap[key];

        const productCode = selectedProduct
          ? selectedProduct.codigo
          : "Código desconocido";

        const already = descripcionSet.has(key);

        if (already) {
          isValid = false;
          message.error(
            `El producto "${productCode}" ya ha sido seleccionado.`
          );
        } else {
          descripcionSet.add(key);
        }
      } else {
        isValid = false;
      }
    });

    if (!isValid) {
      message.error(
        `Debe diligenciar todos los campos de ${fieldName} correctamente antes de continuar.`
      );
    }

    return isValid;
  };

  const calculateSubtotal = (fieldName) => {
    const fieldValues = form.getFieldValue(fieldName) || []; // Obtén los valores de la lista
    if (!Array.isArray(fieldValues)) {
      console.warn(`El campo ${fieldName} no contiene un array válido.`);
      return;
    }

    const subtotal = fieldValues.reduce(
      (acc, item) => acc + (item?.valorTotal || 0),
      0
    );
    setSubtotals((prev) => ({ ...prev, [fieldName]: subtotal }));
  };

  useEffect(() => {
    const totalProyectado = Object.values(subtotals).reduce(
      (acc, val) => acc + val,
      0
    );
    setProyectado(totalProyectado);
  }, [subtotals]);

  const generateJSON = () => {
    // Obtiene todos los valores del formulario
    const formValues = form.getFieldsValue(true); // Asegura obtener los valores completos
    const dataUser = usernameFromState.username; // Extraemos el valor directamente como string
    // Función para mapear los productos
    const mapItemsWithProductDetails = (items) => {
      return items.map((item) => {
        // item.descripcion contiene el OID del producto
        const prod = productosMap[item.descripcion] || {};

        return {
          // Metadatos del producto (vienen de la API)
          oidProducto: prod.oid ?? null,
          codigo: prod.codigo ?? "",
          oid_categoria: prod.oid_categoria ?? null,
          nombreCategoria: prod.nombreCategoria ?? "",
          nombre_producto: prod.nombre_producto ?? "",
          descripcion_producto: prod.descripcion_producto ?? "",
          oid_unidad_medida: prod.oid_unidad_medida ?? null,
          nombreUnidadMedida: prod.nombreUnidadMedida ?? "",
          precio_unitarioPesos: (prod.precio_unitarioPesos ?? "0").toString(),
          precio_usd: (prod.precio_usd ?? "0").toString(),
          clasificacion: prod.clasificacion ?? "",
          simbolo_proyecto: prod.simbolo_proyecto ?? "",
          oid_fin_tipoProducto: prod.oid_fin_tipoProducto ?? null,
          nombreTipoProducto: prod.nombreTipoProducto ?? "",
          unidad_tecnica: prod.unidad_tecnica ?? "",
          estado: prod.estado ?? "Activo",

          // Valores que el usuario editó en el formulario
          recurso: item.recurso ?? "",
          cantidad: item.cantidad ?? 0,
          unidad: item.unidad ?? "",
          valorUnitario: Number(
            parseFloat(
              item.valorUnitario ?? item.precio_unitarioPesos ?? 0
            ).toFixed(2)
          ),
          valorTotal: Number(parseFloat(item.valorTotal ?? 0).toFixed(2)),
          factor: item.factor ?? "",
          subfactor: item.subfactor ?? "",
        };
      });
    };

    // Estructura los datos de cada sección con los detalles del producto
    const dataItems = [
      {
        title: "A. Infraestructura",
        items: mapItemsWithProductDetails(
          formValues.infraestructura,
          "infraestructura"
        ),
      },
      {
        title: "B. Activos Productivos y equipos",
        items: mapItemsWithProductDetails(formValues.activos, "activos"),
      },
      {
        title: "C. Herramientas y Mobiliario",
        items: mapItemsWithProductDetails(
          formValues.herramientas,
          "herramientas"
        ),
      },
      {
        title: "D. Insumos",
        items: mapItemsWithProductDetails(formValues.insumos, "insumos"),
      },
      {
        title: "E. Gastos Operativos",
        items: mapItemsWithProductDetails(formValues.gastos, "gastos"),
      },
      {
        title: "F. Contrapartida",
        items: mapItemsWithProductDetails(
          formValues.contrapartida,
          "contrapartida"
        ),
      },
    ];

    // Calcula el resumen del concepto de inversión
    const totalProyectado = Object.values(subtotals).reduce(
      (acc, val) => acc + val,
      0
    );
    const conceptoInversion = [
      {
        concepto: "A. Infraestructura",
        valor: subtotals.infraestructura,
        porcentaje:
          ((subtotals.infraestructura / totalProyectado) * 100).toFixed(2) +
          "%",
      },
      {
        concepto: "B. Activos Productivos y equipos",
        valor: subtotals.activos,
        porcentaje:
          ((subtotals.activos / totalProyectado) * 100).toFixed(2) + "%",
      },
      {
        concepto: "C. Herramientas y Mobiliario",
        valor: subtotals.herramientas,
        porcentaje:
          ((subtotals.herramientas / totalProyectado) * 100).toFixed(2) + "%",
      },
      {
        concepto: "D. Insumos",
        valor: subtotals.insumos,
        porcentaje:
          ((subtotals.insumos / totalProyectado) * 100).toFixed(2) + "%",
      },
      {
        concepto: "E. Gastos Operativos",
        valor: subtotals.gastos,
        porcentaje:
          ((subtotals.gastos / totalProyectado) * 100).toFixed(2) + "%",
      },
      {
        concepto: "F. Contrapartida",
        valor: subtotals.contrapartida,
        porcentaje:
          ((subtotals.contrapartida / totalProyectado) * 100).toFixed(2) + "%",
      },
      {
        concepto: "TOTAL PROYECTO",
        valor: totalProyectado,
        porcentaje: "100%",
      },
    ];

    // Estructura final del JSON
    return {
      user: dataUser,
      codigoInterno: formValues.codigoInterno || [],
      dataItems,
      conceptoInversion,
    };
  };

  // Función para mostrar modales de confirmación, éxito o error
  const showModalFinish = (type, title, content, onOk = null) => {
    Modal[type]({
      title,
      content,
      okText: "Aceptar", // ✅ Solo el botón "Aceptar"
      cancelText: null, // ✅ Sin botón de cancelar
      onOk: onOk || (() => { }), // ✅ Ejecuta `onOk` si se pasa una función
    });
  };

  const handleFinalizar = async () => {
    showModalFinish(
      "confirm",
      "¿Está segur@ de finalizar?",
      "Una vez registrado el Plan de Compras - SOSTENIBILIDAD, no podrá editar esta información.",
      async () => {
        setLoading(true);

        const generatedJSON = generateJSON();
        // convierte arrays a strings JSON antes de enviar
        const payload = {
          ...generatedJSON,
          dataItems: JSON.stringify(generatedJSON.dataItems),
          conceptoInversion: JSON.stringify(generatedJSON.conceptoInversion),
        };

        try {
          let response;

          if (currentPlan && currentPlan.oid) {
            response = await actualizarPlanCompraSostenibilidad(
              currentPlan.oid,
              generatedJSON,
              initialData
            );
          } else {
            response = await registrarPlanCompraSostenibilidad(generatedJSON);
          }

          if (response.status === 200 || response.status === 201) {
            // 🔹 Asegurar que obtenemos los datos actualizados antes de cerrar el modal
            await fetchPlanes();

            showModalFinish(
              "success",
              currentPlan
                ? "Plan de Compras Actualizado"
                : "Plan de Compras Registrado",
              `El Plan de Compras - SOSTENIBILIDAD ha sido ${currentPlan ? "actualizado" : "guardado"
              } exitosamente.`,
              () => {
                setIsModalOpen(false);
                setCurrentPlan(null);
              }
            );
          } else {
            console.error("⚠️ Error en la respuesta del servidor:", response);
            showModalFinish(
              "error",
              "Error en el Registro",
              `Hubo un problema al ${currentPlan ? "actualizar" : "registrar"
              } el Plan de Compras - SOSTENIBILIDAD. Intente nuevamente.`
            );
          }
        } catch (error) {
          console.error("❌ Error en la conexión con el servidor:", error);
          showModalFinish(
            "error",
            "Error de Conexión",
            "No se pudo conectar con el servidor. Verifique su conexión e intente nuevamente."
          );
        } finally {
          setLoading(false);
        }
      }
    );
  };

  // 🔄 Cargar datos iniciales cuando cambia `planes`
  useEffect(() => {
    setFilteredPlanes(planes); // Sincroniza `filteredPlanes` con `planes`
  }, [planes]);

  // 🔍 Función de búsqueda
  const handleSearch = (e) => {
    const value = e.target.value.trim().toLowerCase();
    setSearchText(value);

    if (!value) {
      setFilteredPlanes(planes);
      return;
    }

    const filtered = planes.filter((plan) => {
      // 1) Buscar en el propio código interno
      if (plan.codigoInterno.toLowerCase().includes(value)) {
        return true;
      }

      // 2) Buscar en cada elemento de dataJson: codPre o implementador
      if (Array.isArray(plan.dataJson)) {
        // convertir a minúsculas para comparar
        return plan.dataJson.some((item) => {
          const codPreMatch = item.codPre?.toLowerCase().includes(value);
          const implMatch = item.implementador?.toLowerCase().includes(value);
          return codPreMatch || implMatch;
        });
      }

      return false;
    });

    setFilteredPlanes(filtered);
  };

  const totalProyecto = Object.values(totals).reduce(
    (acc, val) => acc + val,
    0
  );

  if (!planes || planes.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" />
        <p style={{ marginTop: 16, fontSize: 16, color: "#888" }}>
          Cargando datos...
        </p>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <Header166 type="ps" />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "16px",
        }}
      >
        <Input
          placeholder="Buscar por Código o Implementador"
          value={searchText}
          onChange={handleSearch}
          prefix={<SearchOutlined />}
          allowClear
          style={{ width: 250 }}
        />

        {permissionInsert && (
          <Button type="primary" icon={<PlusOutlined />} onClick={handleCreate}>
            Agregar Plan de Compras
          </Button>
        )}
      </div>

      <Table
        columns={columns}
        dataSource={filteredPlanes} // Ahora siempre tendrá datos correctos
        loading={loading}
        rowKey="oid"
        bordered
        scroll={{ y: 500, x: "max-content" }}
        pagination={{
          current: currentPage, // página actual
          pageSize: pageSize, // filas por página
          total: filteredPlanes.length, // total de registros
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"],
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} de ${total} registros`,
          onChange: (page, size) => {
            setCurrentPage(page);
            setPageSize(size);
          },
        }}
        footer={() => (
          <div
            style={{
              fontWeight: "bold",
              textAlign: "center",
              padding: "10px 0",
              backgroundColor: "#f5f5f5",
            }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",
                gap: "15px",
              }}
            >
              <span>
                Total Infraestructura:{" "}
                {totals.infraestructura.toLocaleString("es-CO", {
                  style: "currency",
                  currency: "COP",
                })}
              </span>
              {renderProgressBar(totals.infraestructura)}

              <span>
                Total Activos:{" "}
                {totals.activos.toLocaleString("es-CO", {
                  style: "currency",
                  currency: "COP",
                })}
              </span>
              {renderProgressBar(totals.activos)}

              <span>
                Total Herramientas:{" "}
                {totals.herramientas.toLocaleString("es-CO", {
                  style: "currency",
                  currency: "COP",
                })}
              </span>
              {renderProgressBar(totals.herramientas)}

              <span>
                Total Insumos:{" "}
                {totals.insumos.toLocaleString("es-CO", {
                  style: "currency",
                  currency: "COP",
                })}
              </span>
              {renderProgressBar(totals.insumos)}

              <span>
                Total Gastos:{" "}
                {totals.gastos.toLocaleString("es-CO", {
                  style: "currency",
                  currency: "COP",
                })}
              </span>
              {renderProgressBar(totals.gastos)}

              <span>
                Total Contrapartidas:{" "}
                {totals.contrapartida.toLocaleString("es-CO", {
                  style: "currency",
                  currency: "COP",
                })}
              </span>
              {renderProgressBar(totals.contrapartida)}

              <span style={{ color: "blue" }}>
                TOTAL PROYECTOS:{" "}
                {totals.total.toLocaleString("es-CO", {
                  style: "currency",
                  currency: "COP",
                })}
              </span>
            </div>
          </div>
        )}
      />

      {/* Modal con formulario wizard */}
      <Modal
        title="Plan de Compras - SOSTENIBILIDAD"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={
          <div
            style={{
              textAlign: "center",
              padding: "10px 0px",
              fontSize: "14px",
              color: "gray",
            }}
          >
            No cierre esta ventana hasta finalizar todos los pasos, la
            información solo se guarda después de validar y finalizar todos los
            pasos.
          </div>
        }
        width="95%"
        styles={{
          body: {
            maxHeight: "80vh",
            overflowY: "auto",
            padding: "1px",
          },
          top: 20,
        }}
      >
        <div style={{ display: "flex", height: "100%" }}>
          {/* Panel de Steps */}
          <div
            style={{
              width: stepsVisible ? "25%" : "0",
              overflow: "hidden",
              borderRight: stepsVisible ? "1px solid #f0f0f0" : "none",
              padding: stepsVisible ? "16px 0px" : "0",
              transition: "width 0.3s",
            }}
          >
            {stepsVisible && (
              <Steps
                direction="vertical"
                current={currentStep}
                onChange={(nextStep) => handleStepChange(nextStep)}
                items={steps.map((step) => ({ title: step.title }))}
              />
            )}
          </div>

          {/* Contenedor del formulario */}
          <div
            style={{
              flex: 1,
              padding: "16px",
              overflowY: "auto", // <-- Agregado para permitir desplazamiento vertical
              maxHeight: "70vh", // <-- Limita la altura del contenido
              transition: "all 0.3s ease",
            }}
          >
            {/* Botón para alternar el panel */}
            <div
              style={{
                display: "flex",
                alignItems: "center", // Alinea verticalmente los elementos
                justifyContent: "space-between",
                gap: "16px", // Espaciado entre el botón y el texto
                marginBottom: "16px",
              }}
            >
              <Button
                type="primary"
                icon={
                  stepsVisible ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />
                }
                onClick={toggleSteps}
                style={{
                  zIndex: 10,
                  transition: "left 0.3s",
                }}
              >
                {stepsVisible ? "Ocultar" : "Mostrar"} Panel
              </Button>

              <h3 style={{ margin: 0 }}>
                Asignación:{" "}
                <span
                  style={{
                    color: proyectado > presupuestoasignado ? "red" : "#198754",
                  }}
                >
                  ${presupuestoasignado.toLocaleString("es-CO")}
                </span>
              </h3>
              <h3 style={{ margin: 0 }}>
                Proyectado:
                <span
                  style={{
                    color: proyectado > presupuestoasignado ? "red" : "#198754",
                  }}
                >
                  {proyectado.toLocaleString("es-CO", {
                    style: "currency",
                    currency: "COP",
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                  })}
                </span>
              </h3>
            </div>

            {/* Contenido dinámico del formulario */}
            <Form
              form={form}
              layout="vertical"
              initialValues={{
                infraestructura: [],
                activos: [],
                herramientas: [],
                insumos: [],
                gastos: [],
                contrapartida: [], // Asegurar que todas las secciones existan
              }}
              onValuesChange={(changedValues, allValues) => {
                const [changedField] = Object.keys(changedValues);
                if (changedField && subtotals.hasOwnProperty(changedField)) {
                  calculateSubtotal(changedField);
                }
              }}
            >
              {currentStep === 0 && (
                <div>
                  <h4
                    style={{
                      background: "#ced4da2b",
                      borderRadius: "10px",
                      paddingLeft: "5px",
                    }}
                  >
                    Seleccione un Proyecto
                  </h4>
                  <Form.Item
                    name="codigoInterno"
                    label="Código Interno"
                    rules={[
                      {
                        required: true,
                        message: "Por favor Seleccione un Proyecto",
                      },
                      {
                        validator: (_, value) => {
                          if (
                            value &&
                            value.some((val) => !/^ES-\d{4}$/.test(val))
                          ) {
                            return Promise.reject(
                              "Algunos códigos no tienen el formato correcto (e.g., ES-0003)"
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Select
                      mode="multiple"
                      showSearch
                      disabled={!!currentPlan}
                      placeholder="Seleccione un Código Interno"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      loading={loading}
                      style={{ width: "100%" }}
                      // 2. deshabilita las opciones cuyo value ya exista
                      options={participantes.map((proj) => ({
                        ...proj,
                        disabled: existingPlanCodes.includes(proj.value),
                      }))}
                      onChange={(value) => {
                        const presupuesto = value.length * 400000000;
                        setPresupuestoasignado(presupuesto);
                      }}
                    />
                  </Form.Item>
                </div>
              )}

              {currentStep === 1 && (
                <div>
                  <h3
                    style={{
                      background: "#ced4da2b",
                      borderRadius: "10px",
                      paddingLeft: "5px",
                    }}
                  >
                    A. Infraestructura
                  </h3>

                  <Form.List name="infraestructura">
                    {(fields, { add, remove }) => (
                      <>
                        {/* Contenedor con scroll horizontal */}
                        <div style={{ overflowX: "auto" }}>
                          <div style={{ minWidth: "1600px" }}>
                            {" "}
                            {/* Ajusta minWidth según columnas */}
                            {/* Encabezado */}
                            {fields.length > 0 && (
                              <Row
                                gutter={16}
                                align="middle"
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: "10px",
                                }}
                                wrap={false} // 🔹 Fuerza que sea una sola fila
                              >
                                <Col flex="50px"></Col>
                                <Col flex="220px">Descripción *</Col>
                                <Col flex="220px">Recurso ARN *</Col>
                                <Col flex="120px">Unidad *</Col>
                                <Col flex="120px">Cantidad *</Col>
                                <Col flex="160px">V/Unitario *</Col>
                                <Col flex="200px">Cofinanciación ARN</Col>
                                <Col flex="200px">Factor</Col>
                                <Col flex="200px">Subfactor</Col>
                                <Col flex="60px"></Col>
                              </Row>
                            )}
                            {fields.map(({ key, name, ...restField }) => {
                              const infraestructuraValues =
                                form.getFieldValue("infraestructura") || [];
                              const currentProduct =
                                infraestructuraValues[name]?.descripcion;

                              const selectedProduct =
                                productosMap[currentProduct] ||
                                infraestructuraValues[name];

                              return (
                                <Row
                                  key={key}
                                  gutter={16}
                                  align="baseline"
                                  wrap={false} // 🔹 Que no salte de línea
                                >
                                  {/* Botón lupa */}
                                  <Col flex="50px">
                                    {currentProduct && (
                                      <Button
                                        type="link"
                                        icon={<FileSearchOutlined />}
                                        onClick={() =>
                                          showProductDetails(selectedProduct)
                                        }
                                        style={{ fontSize: "23px" }}
                                      />
                                    )}
                                  </Col>

                                  {/* Descripción */}
                                  <Col flex="220px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "descripcion"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Seleccione un producto",
                                        },
                                      ]}
                                    >
                                      <Select
                                        showSearch
                                        placeholder="Seleccione un producto"
                                        optionFilterProp="label"
                                        optionLabelProp="label"
                                        notFoundContent={
                                          loading ? <Spin size="small" /> : null
                                        }
                                        options={productosSostenibilidad}
                                        onChange={(value) => {
                                          const selectedProduct =
                                            productosMap[value];
                                          if (selectedProduct) {
                                            const updatedValues =
                                              form.getFieldValue(
                                                "infraestructura"
                                              ) || [];
                                            const currentItem =
                                              updatedValues[name] || {};
                                            updatedValues[name] = {
                                              ...updatedValues[name],
                                              descripcion: value,
                                              unidad:
                                                selectedProduct.nombreUnidadMedida,
                                              oid_unidad_medida:
                                                selectedProduct.oid_unidad_medida,
                                              valorUnitario: parseFloat(
                                                selectedProduct.precio_unitarioPesos
                                              ),
                                              valorTotal:
                                                currentItem?.cantidad &&
                                                  currentItem?.valorUnitario
                                                  ? parseFloat(
                                                    currentItem.valorUnitario
                                                  ) *
                                                  parseFloat(
                                                    currentItem.cantidad
                                                  )
                                                  : 0,
                                            };

                                            form.setFieldsValue({
                                              infraestructura: updatedValues,
                                            });

                                            calculateSubtotal(
                                              "infraestructura"
                                            );
                                            setSelectedProductDetails(
                                              selectedProduct
                                            );
                                          }
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Recurso ARN */}
                                  <Col flex="220px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "recurso"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Seleccione opción",
                                        },
                                      ]}
                                    >
                                      <Select placeholder="Seleccione Recurso ARN">
                                        <Select.Option value="Activos Productivos">
                                          Activos Productivos
                                        </Select.Option>
                                        <Select.Option value="Proceso de Certificación y Permisos">
                                          Proceso de Certificación y Permisos
                                        </Select.Option>
                                        <Select.Option value="Estrategias de Mercadeo y Comercialización">
                                          Estrategias de Mercadeo y
                                          Comercialización
                                        </Select.Option>
                                        <Select.Option value="Procesos de Transformación y Valor Agregado">
                                          Procesos de Transformación y Valor
                                          Agregado
                                        </Select.Option>
                                        <Select.Option value="Innovación Tecnológica">
                                          Innovación Tecnológica
                                        </Select.Option>
                                      </Select>
                                    </Form.Item>
                                  </Col>

                                  {/* Unidad */}
                                  <Col flex="120px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "unidad"]}
                                    >
                                      <Input placeholder="Unidad" readOnly />
                                    </Form.Item>
                                  </Col>

                                  {/* Cantidad */}
                                  <Col flex="120px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "cantidad"]}
                                    >
                                      <InputNumber
                                        placeholder="Cantidad"
                                        style={{ width: "100%" }}
                                        min={1}
                                        onChange={(value) => {
                                          const updatedValues = [
                                            ...infraestructuraValues,
                                          ];
                                          const currentItem =
                                            updatedValues[name] || {};
                                          const valorUnitario = parseFloat(
                                            currentItem.valorUnitario ?? 0
                                          );
                                          updatedValues[name] = {
                                            ...updatedValues[name],
                                            cantidad: value,
                                            valorTotal:
                                              parseFloat(value ?? 0) *
                                              valorUnitario,
                                          };
                                          form.setFieldsValue({
                                            infraestructura: updatedValues,
                                          });
                                          calculateSubtotal("infraestructura");
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Valor Unitario */}
                                  <Col flex="160px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "valorUnitario"]}
                                    >
                                      <InputNumber
                                        placeholder="Valor unitario"
                                        className="input-right-align"
                                        style={{ width: "100%" }}
                                        formatter={(value) =>
                                          new Intl.NumberFormat("es-CO", {
                                            style: "currency",
                                            currency: "COP",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })
                                            .format(value || 0)
                                            .replace(/\s/g, "")
                                        }
                                        parser={(value) =>
                                          parseFloat(
                                            value
                                              .replace(/\./g, "")
                                              .replace(",", ".")
                                              .replace(/[^\d.-]/g, "")
                                          )
                                        }
                                        onChange={(value) => {
                                          const updatedValues = [
                                            ...infraestructuraValues,
                                          ];
                                          const currentItem =
                                            updatedValues[name] || {};
                                          const cantidad = parseFloat(
                                            currentItem.cantidad ?? 0
                                          );
                                          updatedValues[name] = {
                                            ...updatedValues[name],
                                            valorUnitario: value,
                                            valorTotal:
                                              parseFloat(value ?? 0) * cantidad,
                                          };
                                          form.setFieldsValue({
                                            infraestructura: updatedValues,
                                          });
                                          calculateSubtotal("infraestructura");
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Cofinanciación */}
                                  <Col flex="200px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "valorTotal"]}
                                    >
                                      <InputNumber
                                        placeholder="Cofinanciación ARN"
                                        className="input-right-align"
                                        style={{ width: "100%" }}
                                        readOnly
                                        formatter={(value) =>
                                          new Intl.NumberFormat("es-CO", {
                                            style: "currency",
                                            currency: "COP",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })
                                            .format(value || 0)
                                            .replace(/\s/g, "")
                                        }
                                        parser={(value) =>
                                          parseFloat(
                                            value
                                              .replace(/\./g, "")
                                              .replace(",", ".")
                                              .replace(/[^\d.-]/g, "")
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Factor */}
                                  <Col flex="200px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "factor"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Seleccione un factor",
                                        },
                                      ]}
                                    >
                                      <Select
                                        placeholder="Seleccione un factor"
                                        options={factores.map((f) => ({
                                          label: f.factor,
                                          value: f.factor,
                                        }))}
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Subfactor dependiente */}
                                  <Col flex="200px">
                                    <Form.Item
                                      noStyle
                                      shouldUpdate={(
                                        prevValues,
                                        currentValues
                                      ) =>
                                        prevValues.infraestructura?.[name]
                                          ?.factor !==
                                        currentValues.infraestructura?.[name]
                                          ?.factor
                                      }
                                    >
                                      {({ getFieldValue }) => {
                                        const factorSeleccionado =
                                          getFieldValue([
                                            "infraestructura",
                                            name,
                                            "factor",
                                          ]);

                                        const subfactores =
                                          factores.find(
                                            (f) =>
                                              f.factor === factorSeleccionado
                                          )?.subfactores || [];

                                        return (
                                          <Form.Item
                                            {...restField}
                                            name={[name, "subfactor"]}
                                            rules={[
                                              {
                                                required: true,
                                                message:
                                                  "Seleccione un subfactor",
                                              },
                                            ]}
                                          >
                                            <Select
                                              placeholder="Seleccione un subfactor"
                                              options={subfactores.map(
                                                (sf) => ({
                                                  label: sf,
                                                  value: sf,
                                                })
                                              )}
                                            />
                                          </Form.Item>
                                        );
                                      }}
                                    </Form.Item>
                                  </Col>

                                  {/* Fecha Terminación 
                                  <Col flex="200px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "fechaTerminacion"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Seleccione fecha",
                                        },
                                      ]}
                                    >
                                      <DatePicker
                                        format="YYYY-MM-DD"
                                        style={{ width: "100%" }}
                                        placeholder="Seleccione fecha"
                                      />
                                    </Form.Item>
                                  </Col>
                                  */}

                                  {/* Botón eliminar */}
                                  <Col flex="60px">
                                    <Popconfirm
                                      title="¿Estás segur@ de eliminar este ítem?"
                                      onConfirm={() => remove(name)}
                                      okText="Sí"
                                      cancelText="No"
                                    >
                                      <Button
                                        type="primary"
                                        danger
                                        icon={<DeleteOutlined />}
                                      />
                                    </Popconfirm>
                                  </Col>
                                </Row>
                              );
                            })}
                          </div>
                        </div>

                        {/* Botón agregar */}
                        <Form.Item>
                          <Button
                            type="dashed"
                            onClick={() => add()}
                            block
                            icon={<PlusOutlined />}
                          >
                            Agregar ítem
                          </Button>
                        </Form.Item>
                      </>
                    )}
                  </Form.List>

                  {/* Subtotal */}
                  <div>
                    <h6>
                      Subtotal Infraestructura:{" "}
                      {subtotals.infraestructura.toLocaleString("es-CO", {
                        style: "currency",
                        currency: "COP",
                      })}
                    </h6>
                  </div>
                </div>
              )}

              {currentStep === 2 && (
                <div>
                  <h3
                    style={{
                      background: "#ced4da2b",
                      borderRadius: "10px",
                      paddingLeft: "5px",
                    }}
                  >
                    B. Activos Productivos y Equipos
                  </h3>

                  <Form.List name="activos">
                    {(fields, { add, remove }) => (
                      <>
                        {/* Contenedor con scroll horizontal */}
                        <div style={{ overflowX: "auto" }}>
                          <div style={{ minWidth: "1600px" }}>
                            {" "}
                            {/* Ajusta minWidth según tu preferencia */}
                            {/* Encabezado */}
                            {fields.length > 0 && (
                              <Row
                                gutter={16}
                                align="middle"
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: "10px",
                                }}
                                wrap={false}
                              >
                                <Col flex="50px"></Col>
                                <Col flex="220px">Descripción *</Col>
                                <Col flex="220px">Recurso ARN *</Col>
                                <Col flex="120px">Unidad *</Col>
                                <Col flex="120px">Cantidad *</Col>
                                <Col flex="160px">V/Unitario *</Col>
                                <Col flex="200px">Cofinanciación ARN</Col>
                                <Col flex="200px">Factor</Col>
                                <Col flex="200px">Subfactor</Col>
                                <Col flex="60px"></Col>
                              </Row>
                            )}
                            {fields.map(({ key, name, ...restField }) => {
                              const activosValues =
                                form.getFieldValue("activos") || [];
                              const currentProduct =
                                activosValues[name]?.descripcion;
                              const selectedProduct =
                                productosMap[currentProduct] ||
                                activosValues[name];

                              return (
                                <Row
                                  key={key}
                                  gutter={16}
                                  align="baseline"
                                  wrap={false}
                                >
                                  {/* Botón lupa */}
                                  <Col flex="50px">
                                    {currentProduct && (
                                      <Button
                                        type="link"
                                        icon={<FileSearchOutlined />}
                                        onClick={() =>
                                          showProductDetails(selectedProduct)
                                        }
                                        style={{ fontSize: "23px" }}
                                      />
                                    )}
                                  </Col>

                                  {/* Descripción */}
                                  <Col flex="220px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "descripcion"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Seleccione un producto",
                                        },
                                      ]}
                                    >
                                      <Select
                                        showSearch
                                        placeholder="Seleccione un producto"
                                        optionFilterProp="label"
                                        optionLabelProp="label"
                                        notFoundContent={
                                          loading ? <Spin size="small" /> : null
                                        }
                                        options={productosSostenibilidad}
                                        onChange={(value) => {
                                          const selectedProd =
                                            productosMap[value];
                                          if (selectedProd) {
                                            const updatedValues =
                                              form.getFieldValue("activos") ||
                                              [];
                                            const currentItem =
                                              updatedValues[name] || {};
                                            updatedValues[name] = {
                                              ...updatedValues[name],
                                              descripcion: value,
                                              unidad:
                                                selectedProd.nombreUnidadMedida,
                                              oid_unidad_medida:
                                                selectedProd.oid_unidad_medida,
                                              valorUnitario: parseFloat(
                                                selectedProd.precio_unitarioPesos
                                              ),
                                              valorTotal:
                                                currentItem?.cantidad &&
                                                  currentItem?.valorUnitario
                                                  ? parseFloat(
                                                    currentItem.valorUnitario
                                                  ) *
                                                  parseFloat(
                                                    currentItem.cantidad
                                                  )
                                                  : 0,
                                            };

                                            form.setFieldsValue({
                                              activos: updatedValues,
                                            });
                                            calculateSubtotal("activos");
                                            setSelectedProductDetails(
                                              selectedProd
                                            );
                                          } else {
                                            console.warn(
                                              "⚠️ Producto no encontrado en productosMap"
                                            );
                                          }
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Recurso ARN */}
                                  <Col flex="220px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "recurso"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Seleccione opción",
                                        },
                                      ]}
                                    >
                                      <Select placeholder="Seleccione Recurso ARN">
                                        <Select.Option value="Activos Productivos">
                                          Activos Productivos
                                        </Select.Option>
                                        <Select.Option value="Proceso de Certificación y Permisos">
                                          Proceso de Certificación y Permisos
                                        </Select.Option>
                                        <Select.Option value="Estrategias de Mercadeo y Comercialización">
                                          Estrategias de Mercadeo y
                                          Comercialización
                                        </Select.Option>
                                        <Select.Option value="Procesos de Transformación y Valor Agregado">
                                          Procesos de Transformación y Valor
                                          Agregado
                                        </Select.Option>
                                        <Select.Option value="Innovación Tecnológica">
                                          Innovación Tecnológica
                                        </Select.Option>
                                      </Select>
                                    </Form.Item>
                                  </Col>

                                  {/* Unidad */}
                                  <Col flex="120px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "unidad"]}
                                    >
                                      <Input placeholder="Unidad" readOnly />
                                    </Form.Item>
                                  </Col>

                                  {/* Cantidad */}
                                  <Col flex="120px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "cantidad"]}
                                    >
                                      <InputNumber
                                        placeholder="Cantidad"
                                        style={{ width: "100%" }}
                                        min={1}
                                        onChange={(value) => {
                                          const updatedValues = [
                                            ...activosValues,
                                          ];
                                          const currentItem =
                                            updatedValues[name] || {};
                                          const valorUnitario = parseFloat(
                                            currentItem.valorUnitario ?? 0
                                          );
                                          updatedValues[name] = {
                                            ...updatedValues[name],
                                            cantidad: value,
                                            valorTotal:
                                              parseFloat(value ?? 0) *
                                              valorUnitario,
                                          };
                                          form.setFieldsValue({
                                            activos: updatedValues,
                                          });
                                          calculateSubtotal("activos");
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Valor Unitario */}
                                  <Col flex="160px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "valorUnitario"]}
                                    >
                                      <InputNumber
                                        placeholder="Valor unitario"
                                        className="input-right-align"
                                        style={{ width: "100%" }}
                                        formatter={(value) =>
                                          new Intl.NumberFormat("es-CO", {
                                            style: "currency",
                                            currency: "COP",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })
                                            .format(value || 0)
                                            .replace(/\s/g, "")
                                        }
                                        parser={(value) =>
                                          parseFloat(
                                            value
                                              .replace(/\./g, "")
                                              .replace(",", ".")
                                              .replace(/[^\d.-]/g, "")
                                          )
                                        }
                                        onChange={(value) => {
                                          const updatedValues = [
                                            ...activosValues,
                                          ];
                                          const currentItem =
                                            updatedValues[name] || {};
                                          const cantidad = parseFloat(
                                            currentItem.cantidad ?? 0
                                          );
                                          updatedValues[name] = {
                                            ...updatedValues[name],
                                            valorUnitario: value,
                                            valorTotal:
                                              parseFloat(value ?? 0) * cantidad,
                                          };
                                          form.setFieldsValue({
                                            activos: updatedValues,
                                          });
                                          calculateSubtotal("activos");
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Cofinanciación */}
                                  <Col flex="200px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "valorTotal"]}
                                    >
                                      <InputNumber
                                        placeholder="Cofinanciación ARN"
                                        className="input-right-align"
                                        style={{ width: "100%" }}
                                        readOnly
                                        formatter={(value) =>
                                          new Intl.NumberFormat("es-CO", {
                                            style: "currency",
                                            currency: "COP",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })
                                            .format(value || 0)
                                            .replace(/\s/g, "")
                                        }
                                        parser={(value) =>
                                          parseFloat(
                                            value
                                              .replace(/\./g, "")
                                              .replace(",", ".")
                                              .replace(/[^\d.-]/g, "")
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Factor */}
                                  <Col flex="200px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "factor"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Seleccione un factor",
                                        },
                                      ]}
                                    >
                                      <Select
                                        placeholder="Seleccione un factor"
                                        options={factores.map((f) => ({
                                          label: f.factor,
                                          value: f.factor,
                                        }))}
                                        onChange={(value) => {
                                          // Resetear subfactor cuando cambia el factor
                                          const updatedValues =
                                            form.getFieldValue("activos") || [];
                                          updatedValues[name] = {
                                            ...(updatedValues[name] || {}),
                                            factor: value,
                                            subfactor: undefined,
                                          };
                                          form.setFieldsValue({
                                            activos: updatedValues,
                                          });
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Subfactor dependiente del Factor */}
                                  <Col flex="200px">
                                    <Form.Item
                                      noStyle
                                      shouldUpdate={(
                                        prevValues,
                                        currentValues
                                      ) =>
                                        prevValues.activos?.[name]?.factor !==
                                        currentValues.activos?.[name]?.factor
                                      }
                                    >
                                      {({ getFieldValue }) => {
                                        const factorSeleccionado =
                                          getFieldValue([
                                            "activos",
                                            name,
                                            "factor",
                                          ]);
                                        const subfactores =
                                          factores.find(
                                            (f) =>
                                              f.factor === factorSeleccionado
                                          )?.subfactores || [];

                                        return (
                                          <Form.Item
                                            {...restField}
                                            name={[name, "subfactor"]}
                                            rules={[
                                              {
                                                required: true,
                                                message:
                                                  "Seleccione un subfactor",
                                              },
                                            ]}
                                          >
                                            <Select
                                              placeholder="Seleccione un subfactor"
                                              options={subfactores.map(
                                                (sf) => ({
                                                  label: sf,
                                                  value: sf,
                                                })
                                              )}
                                            />
                                          </Form.Item>
                                        );
                                      }}
                                    </Form.Item>
                                  </Col>

                                  {/* Botón eliminar */}
                                  <Col flex="60px">
                                    <Popconfirm
                                      title="¿Estás segur@ de eliminar este ítem?"
                                      onConfirm={() => {
                                        remove(name);
                                        calculateSubtotal("activos");
                                      }}
                                      okText="Sí"
                                      cancelText="No"
                                    >
                                      <Button
                                        type="primary"
                                        danger
                                        icon={<DeleteOutlined />}
                                      />
                                    </Popconfirm>
                                  </Col>
                                </Row>
                              );
                            })}
                          </div>
                        </div>

                        {/* Botón agregar */}
                        <Form.Item>
                          <Button
                            type="dashed"
                            onClick={() => {
                              add();
                              calculateSubtotal("activos");
                            }}
                            block
                            icon={<PlusOutlined />}
                          >
                            Agregar ítem
                          </Button>
                        </Form.Item>
                      </>
                    )}
                  </Form.List>

                  <div>
                    <h6>
                      Subtotal Activos Productivos y Equipos:{" "}
                      {subtotals.activos.toLocaleString("es-CO", {
                        style: "currency",
                        currency: "COP",
                      })}
                    </h6>
                  </div>
                </div>
              )}

              {currentStep === 3 && (
                <div>
                  <h3
                    style={{
                      background: "#ced4da2b",
                      borderRadius: "10px",
                      paddingLeft: "5px",
                    }}
                  >
                    C. Herramientas y Mobiliario
                  </h3>

                  <Form.List name="herramientas">
                    {(fields, { add, remove }) => (
                      <>
                        {/* Contenedor con scroll horizontal */}
                        <div style={{ overflowX: "auto" }}>
                          <div style={{ minWidth: "1600px" }}>
                            {/* Encabezado de la tabla */}
                            {fields.length > 0 && (
                              <Row
                                gutter={16}
                                align="middle"
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: "10px",
                                }}
                                wrap={false}
                              >
                                <Col flex="50px"></Col>
                                <Col flex="220px">Descripción *</Col>
                                <Col flex="220px">Recurso ARN *</Col>
                                <Col flex="120px">Unidad *</Col>
                                <Col flex="120px">Cantidad *</Col>
                                <Col flex="160px">V/Unitario *</Col>
                                <Col flex="200px">Cofinanciación ARN</Col>
                                <Col flex="200px">Factor</Col>
                                <Col flex="200px">Subfactor</Col>
                                <Col flex="60px"></Col>
                              </Row>
                            )}
                            {fields.map(({ key, name, ...restField }) => {
                              // Obtener el valor actual de la fila
                              const herramientasValues =
                                form.getFieldValue("herramientas") || [];
                              const currentProduct =
                                herramientasValues[name]?.descripcion;

                              // Si no encuentra el producto en `productosMap`, buscar en `herramientasValues`
                              const selectedProduct =
                                productosMap[currentProduct] ||
                                herramientasValues[name];

                              return (
                                <Row
                                  key={key}
                                  gutter={16}
                                  align="baseline"
                                  wrap={false}
                                >
                                  {/* Botón con lupa - Solo se muestra si hay un producto seleccionado */}
                                  <Col flex="50px">
                                    {currentProduct && (
                                      <Button
                                        type="link"
                                        icon={<FileSearchOutlined />}
                                        onClick={() =>
                                          showProductDetails(selectedProduct)
                                        }
                                        style={{ fontSize: "23px" }}
                                      />
                                    )}
                                  </Col>

                                  {/* Descripción */}
                                  <Col flex="220px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "descripcion"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Seleccione un producto",
                                        },
                                      ]}
                                    >
                                      <Select
                                        showSearch
                                        placeholder="Seleccione un producto"
                                        optionFilterProp="label"
                                        optionLabelProp="label"
                                        notFoundContent={
                                          loading ? <Spin size="small" /> : null
                                        }
                                        options={productosSostenibilidad}
                                        onChange={(value) => {
                                          // Buscar el producto en `productosMap`
                                          const selectedProd =
                                            productosMap[value];

                                          if (selectedProd) {
                                            const updatedValues =
                                              form.getFieldValue(
                                                "herramientas"
                                              ) || [];
                                            const currentItem =
                                              updatedValues[name] || {};
                                            updatedValues[name] = {
                                              ...updatedValues[name],
                                              descripcion: value,
                                              unidad:
                                                selectedProd.nombreUnidadMedida,
                                              oid_unidad_medida:
                                                selectedProd.oid_unidad_medida,
                                              valorUnitario: parseFloat(
                                                selectedProd.precio_unitarioPesos
                                              ),
                                              valorTotal:
                                                currentItem?.cantidad &&
                                                  currentItem?.valorUnitario
                                                  ? parseFloat(
                                                    currentItem.valorUnitario
                                                  ) *
                                                  parseFloat(
                                                    currentItem.cantidad
                                                  )
                                                  : 0,
                                            };

                                            form.setFieldsValue({
                                              herramientas: updatedValues,
                                            });
                                            calculateSubtotal("herramientas");
                                            setSelectedProductDetails(
                                              selectedProd
                                            );
                                          } else {
                                            console.warn(
                                              "⚠️ Producto no encontrado en productosMap"
                                            );
                                          }
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Recurso ARN */}
                                  <Col flex="220px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "recurso"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Seleccione opción",
                                        },
                                      ]}
                                    >
                                      <Select placeholder="Seleccione Recurso ARN">
                                        <Select.Option value="Activos Productivos">
                                          Activos Productivos
                                        </Select.Option>
                                        <Select.Option value="Proceso de Certificación y Permisos">
                                          Proceso de Certificación y Permisos
                                        </Select.Option>
                                        <Select.Option value="Estrategias de Mercadeo y Comercialización">
                                          Estrategias de Mercadeo y
                                          Comercialización
                                        </Select.Option>
                                        <Select.Option value="Procesos de Transformación y Valor Agregado">
                                          Procesos de Transformación y Valor
                                          Agregado
                                        </Select.Option>
                                        <Select.Option value="Innovación Tecnológica">
                                          Innovación Tecnológica
                                        </Select.Option>
                                      </Select>
                                    </Form.Item>
                                  </Col>

                                  {/* Unidad (Solo Lectura) */}
                                  <Col flex="120px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "unidad"]}
                                    >
                                      <Input placeholder="Unidad" readOnly />
                                    </Form.Item>
                                  </Col>

                                  {/* Cantidad */}
                                  <Col flex="120px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "cantidad"]}
                                    >
                                      <InputNumber
                                        placeholder="Cantidad"
                                        style={{ width: "100%" }}
                                        min={1}
                                        onChange={(value) => {
                                          const updatedValues = [
                                            ...herramientasValues,
                                          ];
                                          const currentItem =
                                            updatedValues[name] || {};
                                          const valorUnitario = parseFloat(
                                            currentItem.valorUnitario ?? 0
                                          );
                                          updatedValues[name] = {
                                            ...updatedValues[name],
                                            cantidad: value,
                                            valorTotal:
                                              parseFloat(value ?? 0) *
                                              valorUnitario,
                                          };
                                          form.setFieldsValue({
                                            herramientas: updatedValues,
                                          });
                                          calculateSubtotal("herramientas");
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Valor Unitario */}
                                  <Col flex="160px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "valorUnitario"]}
                                    >
                                      <InputNumber
                                        placeholder="Valor unitario"
                                        className="input-right-align"
                                        style={{ width: "100%" }}
                                        formatter={(value) =>
                                          new Intl.NumberFormat("es-CO", {
                                            style: "currency",
                                            currency: "COP",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })
                                            .format(value || 0)
                                            .replace(/\s/g, "")
                                        }
                                        parser={(value) =>
                                          parseFloat(
                                            value
                                              .replace(/\./g, "")
                                              .replace(",", ".")
                                              .replace(/[^\d.-]/g, "")
                                          )
                                        }
                                        onChange={(value) => {
                                          const updatedValues = [
                                            ...herramientasValues,
                                          ];
                                          const currentItem =
                                            updatedValues[name] || {};
                                          const cantidad = parseFloat(
                                            currentItem.cantidad ?? 0
                                          );
                                          updatedValues[name] = {
                                            ...updatedValues[name],
                                            valorUnitario: value,
                                            valorTotal:
                                              parseFloat(value ?? 0) * cantidad,
                                          };
                                          form.setFieldsValue({
                                            herramientas: updatedValues,
                                          });
                                          calculateSubtotal("herramientas");
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Cofinanciación ARN (Total) */}
                                  <Col flex="200px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "valorTotal"]}
                                    >
                                      <InputNumber
                                        placeholder="Cofinanciación ARN"
                                        className="input-right-align"
                                        style={{ width: "100%" }}
                                        readOnly
                                        formatter={(value) =>
                                          new Intl.NumberFormat("es-CO", {
                                            style: "currency",
                                            currency: "COP",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })
                                            .format(value || 0)
                                            .replace(/\s/g, "")
                                        }
                                        parser={(value) =>
                                          parseFloat(
                                            value
                                              .replace(/\./g, "")
                                              .replace(",", ".")
                                              .replace(/[^\d.-]/g, "")
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Factor */}
                                  <Col flex="200px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "factor"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Seleccione un factor",
                                        },
                                      ]}
                                    >
                                      <Select
                                        placeholder="Seleccione un factor"
                                        options={factores.map((f) => ({
                                          label: f.factor,
                                          value: f.factor,
                                        }))}
                                        onChange={(value) => {
                                          // Resetear subfactor cuando cambia el factor
                                          const updatedValues =
                                            form.getFieldValue(
                                              "herramientas"
                                            ) || [];
                                          updatedValues[name] = {
                                            ...(updatedValues[name] || {}),
                                            factor: value,
                                            subfactor: undefined,
                                          };
                                          form.setFieldsValue({
                                            herramientas: updatedValues,
                                          });
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Subfactor dependiente del Factor */}
                                  <Col flex="200px">
                                    <Form.Item
                                      noStyle
                                      shouldUpdate={(
                                        prevValues,
                                        currentValues
                                      ) =>
                                        prevValues.herramientas?.[name]
                                          ?.factor !==
                                        currentValues.herramientas?.[name]
                                          ?.factor
                                      }
                                    >
                                      {({ getFieldValue }) => {
                                        const factorSeleccionado =
                                          getFieldValue([
                                            "herramientas",
                                            name,
                                            "factor",
                                          ]);
                                        const subfactores =
                                          factores.find(
                                            (f) =>
                                              f.factor === factorSeleccionado
                                          )?.subfactores || [];

                                        return (
                                          <Form.Item
                                            {...restField}
                                            name={[name, "subfactor"]}
                                            rules={[
                                              {
                                                required: true,
                                                message:
                                                  "Seleccione un subfactor",
                                              },
                                            ]}
                                          >
                                            <Select
                                              placeholder="Seleccione un subfactor"
                                              options={subfactores.map(
                                                (sf) => ({
                                                  label: sf,
                                                  value: sf,
                                                })
                                              )}
                                            />
                                          </Form.Item>
                                        );
                                      }}
                                    </Form.Item>
                                  </Col>

                                  {/* Botón de eliminar */}
                                  <Col flex="60px">
                                    <Popconfirm
                                      title="¿Estás segur@ de eliminar este ítem?"
                                      onConfirm={() => {
                                        remove(name);
                                        calculateSubtotal("herramientas");
                                      }}
                                      okText="Sí"
                                      cancelText="No"
                                    >
                                      <Button
                                        type="primary"
                                        danger
                                        icon={<DeleteOutlined />}
                                      />
                                    </Popconfirm>
                                  </Col>
                                </Row>
                              );
                            })}
                          </div>
                        </div>
                        <Form.Item>
                          <Button
                            type="dashed"
                            onClick={() => {
                              add();
                              calculateSubtotal("herramientas");
                            }}
                            block
                            icon={<PlusOutlined />}
                          >
                            Agregar ítem
                          </Button>
                        </Form.Item>
                      </>
                    )}
                  </Form.List>

                  <div>
                    <h6>
                      Subtotal Herramientas y Mobiliario:{" "}
                      {subtotals.herramientas.toLocaleString("es-CO", {
                        style: "currency",
                        currency: "COP",
                      })}
                    </h6>
                  </div>
                </div>
              )}

              {currentStep === 4 && (
                <div>
                  <h3
                    style={{
                      background: "#ced4da2b",
                      borderRadius: "10px",
                      paddingLeft: "5px",
                    }}
                  >
                    D. Insumos
                  </h3>

                  <Form.List name="insumos">
                    {(fields, { add, remove }) => (
                      <>
                        {/* Contenedor con scroll horizontal */}
                        <div style={{ overflowX: "auto" }}>
                          <div style={{ minWidth: "1600px" }}>
                            {/* Encabezado de la tabla */}
                            {fields.length > 0 && (
                              <Row
                                gutter={16}
                                align="middle"
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: "10px",
                                }}
                                wrap={false}
                              >
                                <Col flex="50px"></Col>
                                <Col flex="220px">Descripción *</Col>
                                <Col flex="220px">Recurso ARN *</Col>
                                <Col flex="120px">Unidad *</Col>
                                <Col flex="120px">Cantidad *</Col>
                                <Col flex="160px">V/Unitario *</Col>
                                <Col flex="200px">Cofinanciación ARN</Col>
                                <Col flex="200px">Factor</Col>
                                <Col flex="200px">Subfactor</Col>
                                <Col flex="60px"></Col>
                              </Row>
                            )}
                            {fields.map(({ key, name, ...restField }) => {
                              // Obtener el valor actual de la fila
                              const insumosValues =
                                form.getFieldValue("insumos") || [];
                              const currentProduct =
                                insumosValues[name]?.descripcion;

                              // Si no encuentra el producto en `productosMap`, buscar en `insumosValues`
                              const selectedProduct =
                                productosMap[currentProduct] ||
                                insumosValues[name];

                              return (
                                <Row
                                  key={key}
                                  gutter={16}
                                  align="baseline"
                                  wrap={false}
                                >
                                  {/* Botón con lupa - Solo se muestra si hay un producto seleccionado */}
                                  <Col flex="50px">
                                    {currentProduct && (
                                      <Button
                                        type="link"
                                        icon={<FileSearchOutlined />}
                                        onClick={() =>
                                          showProductDetails(selectedProduct)
                                        }
                                        style={{ fontSize: "23px" }}
                                      />
                                    )}
                                  </Col>

                                  {/* Descripción */}
                                  <Col flex="220px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "descripcion"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Seleccione un producto",
                                        },
                                      ]}
                                    >
                                      <Select
                                        showSearch
                                        placeholder="Seleccione un producto"
                                        optionFilterProp="label"
                                        optionLabelProp="label"
                                        notFoundContent={
                                          loading ? <Spin size="small" /> : null
                                        }
                                        options={productosSostenibilidad}
                                        onChange={(value) => {
                                          // Buscar el producto en `productosMap`
                                          const selectedProd =
                                            productosMap[value];

                                          if (selectedProd) {
                                            const updatedValues =
                                              form.getFieldValue("insumos") ||
                                              [];
                                            const currentItem =
                                              updatedValues[name] || {};
                                            updatedValues[name] = {
                                              ...updatedValues[name],
                                              descripcion: value,
                                              unidad:
                                                selectedProd.nombreUnidadMedida,
                                              oid_unidad_medida:
                                                selectedProd.oid_unidad_medida,
                                              valorUnitario: parseFloat(
                                                selectedProd.precio_unitarioPesos
                                              ),
                                              valorTotal:
                                                currentItem?.cantidad &&
                                                  currentItem?.valorUnitario
                                                  ? parseFloat(
                                                    currentItem.valorUnitario
                                                  ) *
                                                  parseFloat(
                                                    currentItem.cantidad
                                                  )
                                                  : 0,
                                            };

                                            form.setFieldsValue({
                                              insumos: updatedValues,
                                            });
                                            calculateSubtotal("insumos");
                                            setSelectedProductDetails(
                                              selectedProd
                                            );
                                          } else {
                                            console.warn(
                                              "⚠️ Producto no encontrado en productosMap"
                                            );
                                          }
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Recurso ARN */}
                                  <Col flex="220px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "recurso"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Seleccione opción",
                                        },
                                      ]}
                                    >
                                      <Select placeholder="Seleccione Recurso ARN">
                                        <Select.Option value="Activos Productivos">
                                          Activos Productivos
                                        </Select.Option>
                                        <Select.Option value="Proceso de Certificación y Permisos">
                                          Proceso de Certificación y Permisos
                                        </Select.Option>
                                        <Select.Option value="Estrategias de Mercadeo y Comercialización">
                                          Estrategias de Mercadeo y
                                          Comercialización
                                        </Select.Option>
                                        <Select.Option value="Procesos de Transformación y Valor Agregado">
                                          Procesos de Transformación y Valor
                                          Agregado
                                        </Select.Option>
                                        <Select.Option value="Innovación Tecnológica">
                                          Innovación Tecnológica
                                        </Select.Option>
                                      </Select>
                                    </Form.Item>
                                  </Col>

                                  {/* Unidad (Solo Lectura) */}
                                  <Col flex="120px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "unidad"]}
                                    >
                                      <Input placeholder="Unidad" readOnly />
                                    </Form.Item>
                                  </Col>

                                  {/* Cantidad */}
                                  <Col flex="120px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "cantidad"]}
                                    >
                                      <InputNumber
                                        placeholder="Cantidad"
                                        style={{ width: "100%" }}
                                        min={1}
                                        onChange={(value) => {
                                          const updatedValues = [
                                            ...insumosValues,
                                          ];
                                          const currentItem =
                                            updatedValues[name] || {};
                                          const valorUnitario = parseFloat(
                                            currentItem.valorUnitario ?? 0
                                          );
                                          updatedValues[name] = {
                                            ...updatedValues[name],
                                            cantidad: value,
                                            valorTotal:
                                              parseFloat(value ?? 0) *
                                              valorUnitario,
                                          };
                                          form.setFieldsValue({
                                            insumos: updatedValues,
                                          });
                                          calculateSubtotal("insumos");
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Valor Unitario */}
                                  <Col flex="160px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "valorUnitario"]}
                                    >
                                      <InputNumber
                                        placeholder="Valor unitario"
                                        className="input-right-align"
                                        style={{ width: "100%" }}
                                        formatter={(value) =>
                                          new Intl.NumberFormat("es-CO", {
                                            style: "currency",
                                            currency: "COP",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })
                                            .format(value || 0)
                                            .replace(/\s/g, "")
                                        }
                                        parser={(value) =>
                                          parseFloat(
                                            value
                                              .replace(/\./g, "")
                                              .replace(",", ".")
                                              .replace(/[^\d.-]/g, "")
                                          )
                                        }
                                        onChange={(value) => {
                                          const updatedValues = [
                                            ...insumosValues,
                                          ];
                                          const currentItem =
                                            updatedValues[name] || {};
                                          const cantidad = parseFloat(
                                            currentItem.cantidad ?? 0
                                          );
                                          updatedValues[name] = {
                                            ...updatedValues[name],
                                            valorUnitario: value,
                                            valorTotal:
                                              parseFloat(value ?? 0) * cantidad,
                                          };
                                          form.setFieldsValue({
                                            insumos: updatedValues,
                                          });
                                          calculateSubtotal("insumos");
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Cofinanciación ARN (Total) */}
                                  <Col flex="200px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "valorTotal"]}
                                    >
                                      <InputNumber
                                        placeholder="Cofinanciación ARN"
                                        className="input-right-align"
                                        style={{ width: "100%" }}
                                        readOnly
                                        formatter={(value) =>
                                          new Intl.NumberFormat("es-CO", {
                                            style: "currency",
                                            currency: "COP",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })
                                            .format(value || 0)
                                            .replace(/\s/g, "")
                                        }
                                        parser={(value) =>
                                          parseFloat(
                                            value
                                              .replace(/\./g, "")
                                              .replace(",", ".")
                                              .replace(/[^\d.-]/g, "")
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Factor */}
                                  <Col flex="200px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "factor"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Seleccione un factor",
                                        },
                                      ]}
                                    >
                                      <Select
                                        placeholder="Seleccione un factor"
                                        options={factores.map((f) => ({
                                          label: f.factor,
                                          value: f.factor,
                                        }))}
                                        onChange={(value) => {
                                          // Resetear subfactor cuando cambia el factor
                                          const updatedValues =
                                            form.getFieldValue("insumos") || [];
                                          updatedValues[name] = {
                                            ...(updatedValues[name] || {}),
                                            factor: value,
                                            subfactor: undefined,
                                          };
                                          form.setFieldsValue({
                                            insumos: updatedValues,
                                          });
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Subfactor dependiente del Factor */}
                                  <Col flex="200px">
                                    <Form.Item
                                      noStyle
                                      shouldUpdate={(
                                        prevValues,
                                        currentValues
                                      ) =>
                                        prevValues.insumos?.[name]?.factor !==
                                        currentValues.insumos?.[name]?.factor
                                      }
                                    >
                                      {({ getFieldValue }) => {
                                        const factorSeleccionado =
                                          getFieldValue([
                                            "insumos",
                                            name,
                                            "factor",
                                          ]);
                                        const subfactores =
                                          factores.find(
                                            (f) =>
                                              f.factor === factorSeleccionado
                                          )?.subfactores || [];

                                        return (
                                          <Form.Item
                                            {...restField}
                                            name={[name, "subfactor"]}
                                            rules={[
                                              {
                                                required: true,
                                                message:
                                                  "Seleccione un subfactor",
                                              },
                                            ]}
                                          >
                                            <Select
                                              placeholder="Seleccione un subfactor"
                                              options={subfactores.map(
                                                (sf) => ({
                                                  label: sf,
                                                  value: sf,
                                                })
                                              )}
                                            />
                                          </Form.Item>
                                        );
                                      }}
                                    </Form.Item>
                                  </Col>

                                  {/* Botón de eliminar */}
                                  <Col flex="60px">
                                    <Popconfirm
                                      title="¿Estás segur@ de eliminar este ítem?"
                                      onConfirm={() => {
                                        remove(name);
                                        calculateSubtotal("insumos");
                                      }}
                                      okText="Sí"
                                      cancelText="No"
                                    >
                                      <Button
                                        type="primary"
                                        danger
                                        icon={<DeleteOutlined />}
                                      />
                                    </Popconfirm>
                                  </Col>
                                </Row>
                              );
                            })}
                          </div>
                        </div>
                        <Form.Item>
                          <Button
                            type="dashed"
                            onClick={() => {
                              add();
                              calculateSubtotal("insumos");
                            }}
                            block
                            icon={<PlusOutlined />}
                          >
                            Agregar ítem
                          </Button>
                        </Form.Item>
                      </>
                    )}
                  </Form.List>

                  <div>
                    <h6>
                      Subtotal Insumos:{" "}
                      {subtotals.insumos.toLocaleString("es-CO", {
                        style: "currency",
                        currency: "COP",
                      })}
                    </h6>
                  </div>
                </div>
              )}

              {currentStep === 5 && (
                <div>
                  <h3
                    style={{
                      background: "#ced4da2b",
                      borderRadius: "10px",
                      paddingLeft: "5px",
                    }}
                  >
                    E. Gastos Operativos
                  </h3>

                  <Form.List name="gastos">
                    {(fields, { add, remove }) => (
                      <>
                        {/* Contenedor con scroll horizontal */}
                        <div style={{ overflowX: "auto" }}>
                          <div style={{ minWidth: "1600px" }}>
                            {/* Encabezado de la tabla */}
                            {fields.length > 0 && (
                              <Row
                                gutter={16}
                                align="middle"
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: "10px",
                                }}
                                wrap={false}
                              >
                                <Col flex="50px"></Col>
                                <Col flex="220px">Descripción *</Col>
                                <Col flex="220px">Recurso ARN *</Col>
                                <Col flex="120px">Unidad *</Col>
                                <Col flex="120px">Cantidad *</Col>
                                <Col flex="160px">V/Unitario *</Col>
                                <Col flex="200px">Cofinanciación ARN</Col>
                                <Col flex="200px">Factor</Col>
                                <Col flex="200px">Subfactor</Col>
                                <Col flex="60px"></Col>
                              </Row>
                            )}
                            {fields.map(({ key, name, ...restField }) => {
                              // Obtener el valor actual de la fila
                              const gastosValues =
                                form.getFieldValue("gastos") || [];
                              const currentProduct =
                                gastosValues[name]?.descripcion;

                              // Si no encuentra el producto en `productosMap`, buscar en `gastosValues`
                              const selectedProduct =
                                productosMap[currentProduct] ||
                                gastosValues[name];

                              return (
                                <Row
                                  key={key}
                                  gutter={16}
                                  align="baseline"
                                  wrap={false}
                                >
                                  {/* Botón con lupa - Solo se muestra si hay un producto seleccionado */}
                                  <Col flex="50px">
                                    {currentProduct && (
                                      <Button
                                        type="link"
                                        icon={<FileSearchOutlined />}
                                        onClick={() =>
                                          showProductDetails(selectedProduct)
                                        }
                                        style={{ fontSize: "23px" }}
                                      />
                                    )}
                                  </Col>

                                  {/* Descripción */}
                                  <Col flex="220px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "descripcion"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Seleccione un producto",
                                        },
                                      ]}
                                    >
                                      <Select
                                        showSearch
                                        placeholder="Seleccione un producto"
                                        optionFilterProp="label"
                                        optionLabelProp="label"
                                        notFoundContent={
                                          loading ? <Spin size="small" /> : null
                                        }
                                        options={productosSostenibilidad}
                                        onChange={(value) => {
                                          // Buscar el producto en `productosMap`
                                          const selectedProd =
                                            productosMap[value];

                                          if (selectedProd) {
                                            const updatedValues =
                                              form.getFieldValue("gastos") ||
                                              [];
                                            const currentItem =
                                              updatedValues[name] || {};
                                            updatedValues[name] = {
                                              ...updatedValues[name],
                                              descripcion: value,
                                              unidad:
                                                selectedProd.nombreUnidadMedida,
                                              oid_unidad_medida:
                                                selectedProd.oid_unidad_medida,
                                              valorUnitario: parseFloat(
                                                selectedProd.precio_unitarioPesos
                                              ),
                                              valorTotal:
                                                currentItem?.cantidad &&
                                                  currentItem?.valorUnitario
                                                  ? parseFloat(
                                                    currentItem.valorUnitario
                                                  ) *
                                                  parseFloat(
                                                    currentItem.cantidad
                                                  )
                                                  : 0,
                                            };

                                            form.setFieldsValue({
                                              gastos: updatedValues,
                                            });
                                            calculateSubtotal("gastos");
                                            setSelectedProductDetails(
                                              selectedProd
                                            );
                                          } else {
                                            console.warn(
                                              "⚠️ Producto no encontrado en productosMap"
                                            );
                                          }
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Recurso ARN */}
                                  <Col flex="220px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "recurso"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Seleccione opción",
                                        },
                                      ]}
                                    >
                                      <Select placeholder="Seleccione Recurso ARN">
                                        <Select.Option value="Activos Productivos">
                                          Activos Productivos
                                        </Select.Option>
                                        <Select.Option value="Proceso de Certificación y Permisos">
                                          Proceso de Certificación y Permisos
                                        </Select.Option>
                                        <Select.Option value="Estrategias de Mercadeo y Comercialización">
                                          Estrategias de Mercadeo y
                                          Comercialización
                                        </Select.Option>
                                        <Select.Option value="Procesos de Transformación y Valor Agregado">
                                          Procesos de Transformación y Valor
                                          Agregado
                                        </Select.Option>
                                        <Select.Option value="Innovación Tecnológica">
                                          Innovación Tecnológica
                                        </Select.Option>
                                      </Select>
                                    </Form.Item>
                                  </Col>

                                  {/* Unidad (Solo Lectura) */}
                                  <Col flex="120px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "unidad"]}
                                    >
                                      <Input placeholder="Unidad" readOnly />
                                    </Form.Item>
                                  </Col>

                                  {/* Cantidad */}
                                  <Col flex="120px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "cantidad"]}
                                    >
                                      <InputNumber
                                        placeholder="Cantidad"
                                        style={{ width: "100%" }}
                                        min={1}
                                        onChange={(value) => {
                                          const updatedValues = [
                                            ...gastosValues,
                                          ];
                                          const currentItem =
                                            updatedValues[name] || {};
                                          const valorUnitario = parseFloat(
                                            currentItem.valorUnitario ?? 0
                                          );
                                          updatedValues[name] = {
                                            ...updatedValues[name],
                                            cantidad: value,
                                            valorTotal:
                                              parseFloat(value ?? 0) *
                                              valorUnitario,
                                          };
                                          form.setFieldsValue({
                                            gastos: updatedValues,
                                          });
                                          calculateSubtotal("gastos");
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Valor Unitario */}
                                  <Col flex="160px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "valorUnitario"]}
                                    >
                                      <InputNumber
                                        placeholder="Valor unitario"
                                        className="input-right-align"
                                        style={{ width: "100%" }}
                                        formatter={(value) =>
                                          new Intl.NumberFormat("es-CO", {
                                            style: "currency",
                                            currency: "COP",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })
                                            .format(value || 0)
                                            .replace(/\s/g, "")
                                        }
                                        parser={(value) =>
                                          parseFloat(
                                            value
                                              .replace(/\./g, "")
                                              .replace(",", ".")
                                              .replace(/[^\d.-]/g, "")
                                          )
                                        }
                                        onChange={(value) => {
                                          const updatedValues = [
                                            ...gastosValues,
                                          ];
                                          const currentItem =
                                            updatedValues[name] || {};
                                          const cantidad = parseFloat(
                                            currentItem.cantidad ?? 0
                                          );
                                          updatedValues[name] = {
                                            ...updatedValues[name],
                                            valorUnitario: value,
                                            valorTotal:
                                              parseFloat(value ?? 0) * cantidad,
                                          };
                                          form.setFieldsValue({
                                            gastos: updatedValues,
                                          });
                                          calculateSubtotal("gastos");
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Cofinanciación ARN (Total) */}
                                  <Col flex="200px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "valorTotal"]}
                                    >
                                      <InputNumber
                                        placeholder="Cofinanciación ARN"
                                        className="input-right-align"
                                        style={{ width: "100%" }}
                                        readOnly
                                        formatter={(value) =>
                                          new Intl.NumberFormat("es-CO", {
                                            style: "currency",
                                            currency: "COP",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })
                                            .format(value || 0)
                                            .replace(/\s/g, "")
                                        }
                                        parser={(value) =>
                                          parseFloat(
                                            value
                                              .replace(/\./g, "")
                                              .replace(",", ".")
                                              .replace(/[^\d.-]/g, "")
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Factor */}
                                  <Col flex="200px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "factor"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Seleccione un factor",
                                        },
                                      ]}
                                    >
                                      <Select
                                        placeholder="Seleccione un factor"
                                        options={factores.map((f) => ({
                                          label: f.factor,
                                          value: f.factor,
                                        }))}
                                        onChange={(value) => {
                                          // Resetear subfactor cuando cambia el factor
                                          const updatedValues =
                                            form.getFieldValue("gastos") || [];
                                          updatedValues[name] = {
                                            ...(updatedValues[name] || {}),
                                            factor: value,
                                            subfactor: undefined,
                                          };
                                          form.setFieldsValue({
                                            gastos: updatedValues,
                                          });
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Subfactor dependiente del Factor */}
                                  <Col flex="200px">
                                    <Form.Item
                                      noStyle
                                      shouldUpdate={(
                                        prevValues,
                                        currentValues
                                      ) =>
                                        prevValues.gastos?.[name]?.factor !==
                                        currentValues.gastos?.[name]?.factor
                                      }
                                    >
                                      {({ getFieldValue }) => {
                                        const factorSeleccionado =
                                          getFieldValue([
                                            "gastos",
                                            name,
                                            "factor",
                                          ]);
                                        const subfactores =
                                          factores.find(
                                            (f) =>
                                              f.factor === factorSeleccionado
                                          )?.subfactores || [];

                                        return (
                                          <Form.Item
                                            {...restField}
                                            name={[name, "subfactor"]}
                                            rules={[
                                              {
                                                required: true,
                                                message:
                                                  "Seleccione un subfactor",
                                              },
                                            ]}
                                          >
                                            <Select
                                              placeholder="Seleccione un subfactor"
                                              options={subfactores.map(
                                                (sf) => ({
                                                  label: sf,
                                                  value: sf,
                                                })
                                              )}
                                            />
                                          </Form.Item>
                                        );
                                      }}
                                    </Form.Item>
                                  </Col>

                                  {/* Botón de eliminar */}
                                  <Col flex="60px">
                                    <Popconfirm
                                      title="¿Estás segur@ de eliminar este ítem?"
                                      onConfirm={() => {
                                        remove(name);
                                        calculateSubtotal("gastos");
                                      }}
                                      okText="Sí"
                                      cancelText="No"
                                    >
                                      <Button
                                        type="primary"
                                        danger
                                        icon={<DeleteOutlined />}
                                      />
                                    </Popconfirm>
                                  </Col>
                                </Row>
                              );
                            })}
                          </div>
                        </div>
                        <Form.Item>
                          <Button
                            type="dashed"
                            onClick={() => {
                              add();
                              calculateSubtotal("gastos");
                            }}
                            block
                            icon={<PlusOutlined />}
                          >
                            Agregar ítem
                          </Button>
                        </Form.Item>
                      </>
                    )}
                  </Form.List>

                  <div>
                    <h6>
                      Subtotal Gastos Operativos:{" "}
                      {subtotals.gastos.toLocaleString("es-CO", {
                        style: "currency",
                        currency: "COP",
                      })}
                    </h6>
                  </div>
                </div>
              )}

              {currentStep === 6 && (
                <div>
                  <h3
                    style={{
                      background: "#ced4da2b",
                      borderRadius: "10px",
                      paddingLeft: "5px",
                    }}
                  >
                    F. Contrapartida
                  </h3>

                  <Form.List name="contrapartida">
                    {(fields, { add, remove }) => (
                      <>
                        {/* Contenedor con scroll horizontal */}
                        <div style={{ overflowX: "auto" }}>
                          <div style={{ minWidth: "1600px" }}>
                            {/* Encabezado de la tabla */}
                            {fields.length > 0 && (
                              <Row
                                gutter={16}
                                align="middle"
                                style={{
                                  fontWeight: "bold",
                                  marginBottom: "10px",
                                }}
                                wrap={false}
                              >
                                <Col flex="50px"></Col>
                                <Col flex="220px">Descripción *</Col>
                                <Col flex="220px">Recurso ARN *</Col>
                                <Col flex="120px">Unidad *</Col>
                                <Col flex="120px">Cantidad *</Col>
                                <Col flex="160px">V/Unitario *</Col>
                                <Col flex="200px">Cofinanciación ARN</Col>
                                <Col flex="200px">Factor</Col>
                                <Col flex="200px">Subfactor</Col>
                                <Col flex="60px"></Col>
                              </Row>
                            )}
                            {fields.map(({ key, name, ...restField }) => {
                              // Obtener el valor actual de la fila
                              const contrapartidaValues =
                                form.getFieldValue("contrapartida") || [];
                              const currentProduct =
                                contrapartidaValues[name]?.descripcion;

                              // Si no encuentra el producto en `productosMap`, buscar en `contrapartidaValues`
                              const selectedProduct =
                                productosMap[currentProduct] ||
                                contrapartidaValues[name];

                              return (
                                <Row
                                  key={key}
                                  gutter={16}
                                  align="baseline"
                                  wrap={false}
                                >
                                  {/* Botón con lupa - Solo se muestra si hay un producto seleccionado */}
                                  <Col flex="50px">
                                    {currentProduct && (
                                      <Button
                                        type="link"
                                        icon={<FileSearchOutlined />}
                                        onClick={() =>
                                          showProductDetails(selectedProduct)
                                        }
                                        style={{ fontSize: "23px" }}
                                      />
                                    )}
                                  </Col>

                                  {/* Descripción */}
                                  <Col flex="220px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "descripcion"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Seleccione un producto",
                                        },
                                      ]}
                                    >
                                      <Select
                                        showSearch
                                        placeholder="Seleccione un producto"
                                        optionFilterProp="label"
                                        optionLabelProp="label"
                                        notFoundContent={
                                          loading ? <Spin size="small" /> : null
                                        }
                                        options={productosSostenibilidad}
                                        onChange={(value) => {
                                          // Buscar el producto en `productosMap`
                                          const selectedProd =
                                            productosMap[value];

                                          if (selectedProd) {
                                            const updatedValues =
                                              form.getFieldValue(
                                                "contrapartida"
                                              ) || [];
                                            const currentItem =
                                              updatedValues[name] || {};
                                            updatedValues[name] = {
                                              ...updatedValues[name],
                                              descripcion: value,
                                              unidad:
                                                selectedProd.nombreUnidadMedida,
                                              oid_unidad_medida:
                                                selectedProd.oid_unidad_medida,
                                              valorUnitario: parseFloat(
                                                selectedProd.precio_unitarioPesos
                                              ),
                                              valorTotal:
                                                currentItem?.cantidad &&
                                                  currentItem?.valorUnitario
                                                  ? parseFloat(
                                                    currentItem.valorUnitario
                                                  ) *
                                                  parseFloat(
                                                    currentItem.cantidad
                                                  )
                                                  : 0,
                                            };

                                            form.setFieldsValue({
                                              contrapartida: updatedValues,
                                            });
                                            calculateSubtotal("contrapartida");
                                            setSelectedProductDetails(
                                              selectedProd
                                            );
                                          } else {
                                            console.warn(
                                              "⚠️ Producto no encontrado en productosMap"
                                            );
                                          }
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Recurso ARN */}
                                  <Col flex="220px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "recurso"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Seleccione opción",
                                        },
                                      ]}
                                    >
                                      <Select placeholder="Seleccione Recurso ARN">
                                        <Select.Option value="Activos Productivos">
                                          Activos Productivos
                                        </Select.Option>
                                        <Select.Option value="Proceso de Certificación y Permisos">
                                          Proceso de Certificación y Permisos
                                        </Select.Option>
                                        <Select.Option value="Estrategias de Mercadeo y Comercialización">
                                          Estrategias de Mercadeo y
                                          Comercialización
                                        </Select.Option>
                                        <Select.Option value="Procesos de Transformación y Valor Agregado">
                                          Procesos de Transformación y Valor
                                          Agregado
                                        </Select.Option>
                                        <Select.Option value="Innovación Tecnológica">
                                          Innovación Tecnológica
                                        </Select.Option>
                                      </Select>
                                    </Form.Item>
                                  </Col>

                                  {/* Unidad (Solo Lectura) */}
                                  <Col flex="120px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "unidad"]}
                                    >
                                      <Input placeholder="Unidad" readOnly />
                                    </Form.Item>
                                  </Col>

                                  {/* Cantidad */}
                                  <Col flex="120px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "cantidad"]}
                                    >
                                      <InputNumber
                                        placeholder="Cantidad"
                                        style={{ width: "100%" }}
                                        min={1}
                                        onChange={(value) => {
                                          const updatedValues = [
                                            ...contrapartidaValues,
                                          ];
                                          const currentItem =
                                            updatedValues[name] || {};
                                          const valorUnitario = parseFloat(
                                            currentItem.valorUnitario ?? 0
                                          );
                                          updatedValues[name] = {
                                            ...updatedValues[name],
                                            cantidad: value,
                                            valorTotal:
                                              parseFloat(value ?? 0) *
                                              valorUnitario,
                                          };
                                          form.setFieldsValue({
                                            contrapartida: updatedValues,
                                          });
                                          calculateSubtotal("contrapartida");
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Valor Unitario */}
                                  <Col flex="160px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "valorUnitario"]}
                                    >
                                      <InputNumber
                                        placeholder="Valor unitario"
                                        className="input-right-align"
                                        style={{ width: "100%" }}
                                        formatter={(value) =>
                                          new Intl.NumberFormat("es-CO", {
                                            style: "currency",
                                            currency: "COP",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })
                                            .format(value || 0)
                                            .replace(/\s/g, "")
                                        }
                                        parser={(value) =>
                                          parseFloat(
                                            value
                                              .replace(/\./g, "")
                                              .replace(",", ".")
                                              .replace(/[^\d.-]/g, "")
                                          )
                                        }
                                        onChange={(value) => {
                                          const updatedValues = [
                                            ...contrapartidaValues,
                                          ];
                                          const currentItem =
                                            updatedValues[name] || {};
                                          const cantidad = parseFloat(
                                            currentItem.cantidad ?? 0
                                          );
                                          updatedValues[name] = {
                                            ...updatedValues[name],
                                            valorUnitario: value,
                                            valorTotal:
                                              parseFloat(value ?? 0) * cantidad,
                                          };
                                          form.setFieldsValue({
                                            contrapartida: updatedValues,
                                          });
                                          calculateSubtotal("contrapartida");
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Cofinanciación ARN (Total) */}
                                  <Col flex="200px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "valorTotal"]}
                                    >
                                      <InputNumber
                                        placeholder="Cofinanciación ARN"
                                        className="input-right-align"
                                        style={{ width: "100%" }}
                                        readOnly
                                        formatter={(value) =>
                                          new Intl.NumberFormat("es-CO", {
                                            style: "currency",
                                            currency: "COP",
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })
                                            .format(value || 0)
                                            .replace(/\s/g, "")
                                        }
                                        parser={(value) =>
                                          parseFloat(
                                            value
                                              .replace(/\./g, "")
                                              .replace(",", ".")
                                              .replace(/[^\d.-]/g, "")
                                          )
                                        }
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Factor */}
                                  <Col flex="200px">
                                    <Form.Item
                                      {...restField}
                                      name={[name, "factor"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Seleccione un factor",
                                        },
                                      ]}
                                    >
                                      <Select
                                        placeholder="Seleccione un factor"
                                        options={factores.map((f) => ({
                                          label: f.factor,
                                          value: f.factor,
                                        }))}
                                        onChange={(value) => {
                                          // Resetear subfactor cuando cambia el factor
                                          const updatedValues =
                                            form.getFieldValue(
                                              "contrapartida"
                                            ) || [];
                                          updatedValues[name] = {
                                            ...(updatedValues[name] || {}),
                                            factor: value,
                                            subfactor: undefined,
                                          };
                                          form.setFieldsValue({
                                            contrapartida: updatedValues,
                                          });
                                        }}
                                      />
                                    </Form.Item>
                                  </Col>

                                  {/* Subfactor dependiente del Factor */}
                                  <Col flex="200px">
                                    <Form.Item
                                      noStyle
                                      shouldUpdate={(
                                        prevValues,
                                        currentValues
                                      ) =>
                                        prevValues.contrapartida?.[name]
                                          ?.factor !==
                                        currentValues.contrapartida?.[name]
                                          ?.factor
                                      }
                                    >
                                      {({ getFieldValue }) => {
                                        const factorSeleccionado =
                                          getFieldValue([
                                            "contrapartida",
                                            name,
                                            "factor",
                                          ]);
                                        const subfactores =
                                          factores.find(
                                            (f) =>
                                              f.factor === factorSeleccionado
                                          )?.subfactores || [];

                                        return (
                                          <Form.Item
                                            {...restField}
                                            name={[name, "subfactor"]}
                                            rules={[
                                              {
                                                required: true,
                                                message:
                                                  "Seleccione un subfactor",
                                              },
                                            ]}
                                          >
                                            <Select
                                              placeholder="Seleccione un subfactor"
                                              options={subfactores.map(
                                                (sf) => ({
                                                  label: sf,
                                                  value: sf,
                                                })
                                              )}
                                            />
                                          </Form.Item>
                                        );
                                      }}
                                    </Form.Item>
                                  </Col>

                                  {/* Botón de eliminar */}
                                  <Col flex="60px">
                                    <Popconfirm
                                      title="¿Estás segur@ de eliminar este ítem?"
                                      onConfirm={() => {
                                        remove(name);
                                        calculateSubtotal("contrapartida");
                                      }}
                                      okText="Sí"
                                      cancelText="No"
                                    >
                                      <Button
                                        type="primary"
                                        danger
                                        icon={<DeleteOutlined />}
                                      />
                                    </Popconfirm>
                                  </Col>
                                </Row>
                              );
                            })}
                          </div>
                        </div>
                        <Form.Item>
                          <Button
                            type="dashed"
                            onClick={() => {
                              add();
                              calculateSubtotal("contrapartida");
                            }}
                            block
                            icon={<PlusOutlined />}
                          >
                            Agregar ítem
                          </Button>
                        </Form.Item>
                      </>
                    )}
                  </Form.List>

                  <div>
                    <h6>
                      Subtotal Contrapartida:{" "}
                      {subtotals.contrapartida.toLocaleString("es-CO", {
                        style: "currency",
                        currency: "COP",
                      })}
                    </h6>
                  </div>
                </div>
              )}
              {currentStep === 7 && (
                <div>
                  <h3
                    style={{
                      background: "#ced4da2b",
                      borderRadius: "10px",
                      paddingLeft: "5px",
                    }}
                  >
                    Concepto de la inversión
                  </h3>
                  <Table
                    className="custom-table"
                    components={{
                      body: {
                        cell: (props) => (
                          <td {...props} style={{ textAlign: "center" }} />
                        ),
                      },
                    }}
                    dataSource={[
                      {
                        key: "1",
                        concepto: "A. Infraestructura",
                        valor: subtotals.infraestructura,
                        porcentaje:
                          (
                            (subtotals.infraestructura /
                              Object.values(subtotals).reduce(
                                (acc, val) => acc + val,
                                0
                              )) *
                            100
                          ).toFixed(2) + "%",
                      },
                      {
                        key: "2",
                        concepto: "B. Activos Productivos y equipos",
                        valor: subtotals.activos,
                        porcentaje:
                          (
                            (subtotals.activos /
                              Object.values(subtotals).reduce(
                                (acc, val) => acc + val,
                                0
                              )) *
                            100
                          ).toFixed(2) + "%",
                      },
                      {
                        key: "3",
                        concepto: "C. Herramientas y Mobiliario",
                        valor: subtotals.herramientas,
                        porcentaje:
                          (
                            (subtotals.herramientas /
                              Object.values(subtotals).reduce(
                                (acc, val) => acc + val,
                                0
                              )) *
                            100
                          ).toFixed(2) + "%",
                      },
                      {
                        key: "4",
                        concepto: "D. Insumos",
                        valor: subtotals.insumos,
                        porcentaje:
                          (
                            (subtotals.insumos /
                              Object.values(subtotals).reduce(
                                (acc, val) => acc + val,
                                0
                              )) *
                            100
                          ).toFixed(2) + "%",
                      },
                      {
                        key: "5",
                        concepto: "E. Gastos Operativos",
                        valor: subtotals.gastos,
                        porcentaje:
                          (
                            (subtotals.gastos /
                              Object.values(subtotals).reduce(
                                (acc, val) => acc + val,
                                0
                              )) *
                            100
                          ).toFixed(2) + "%",
                      },
                      {
                        key: "6",
                        concepto: "F. Contrapartida",
                        valor: subtotals.contrapartida,
                        porcentaje:
                          (
                            (subtotals.contrapartida /
                              Object.values(subtotals).reduce(
                                (acc, val) => acc + val,
                                0
                              )) *
                            100
                          ).toFixed(2) + "%",
                      },
                      {
                        key: "7",
                        concepto: "TOTAL PROYECTO",
                        valor: Object.values(subtotals).reduce(
                          (acc, val) => acc + val,
                          0
                        ),
                        porcentaje: "100%",
                      },
                    ]}
                    columns={[
                      {
                        title: (
                          <div
                            style={{ textAlign: "center", fontWeight: "bold" }}
                          >
                            Concepto
                          </div>
                        ),
                        dataIndex: "concepto",
                        key: "concepto",
                      },
                      {
                        title: (
                          <div
                            style={{ textAlign: "center", fontWeight: "bold" }}
                          >
                            Valor Cofinanciación y Contrapartida
                          </div>
                        ),
                        dataIndex: "valor",
                        key: "valor",
                        align: "right",
                        render: (value) =>
                          value.toLocaleString("es-CO", {
                            style: "currency",
                            currency: "COP",
                          }),
                      },
                      {
                        title: (
                          <div
                            style={{ textAlign: "center", fontWeight: "bold" }}
                          >
                            % del total del proyecto
                          </div>
                        ),
                        dataIndex: "porcentaje",
                        key: "porcentaje",
                        align: "center",
                      },
                    ]}
                    pagination={false}
                    rowClassName={(record) =>
                      record.key === "7" ? "total-row" : ""
                    }
                    style={{
                      fontSize: "14px",
                      lineHeight: "1.2",
                      marginBottom: "20px",
                    }}
                  />
                  <style>
                    {`
        .ant-table-thead > tr > th {
            background-color: #f5f5f5;
            font-size: 14px;
            text-align: center;
            padding: 10px 10px !important;
        }
        .ant-table-row {
            font-size: 13px;
        }
        .ant-table-cell {
            padding: 10px 10px !important;
        }
        .total-row {
            font-weight: bold;
            background-color: #fafafa;
        }
    `}
                  </style>
                </div>
              )}

              <div className="d-flex justify-content-between mt-4">
                {currentStep > 0 && (
                  <Button onClick={prev} style={{ marginRight: "8px" }}>
                    Anterior
                  </Button>
                )}

                {currentStep < steps.length - 1 && (
                  <Button type="primary" onClick={next}>
                    Siguiente
                  </Button>
                )}

                {/* Botón "Finalizar" o mensaje de error */}
                {currentStep === steps.length - 1 &&
                  (isExceeding ? (
                    <p style={{ color: "red", fontWeight: "bold" }}>
                      El formulario tiene errores: el monto proyectado excede el
                      presupuesto asignado.
                    </p>
                  ) : proyectado === 0 ? (
                    <p style={{ color: "red", fontWeight: "bold" }}>
                      El monto proyectado no puede ser cero. Por favor, registre
                      al menos un dato para continuar.
                    </p>
                  ) : (
                    <Button
                      type="primary"
                      onClick={handleFinalizar}
                      loading={loading}
                      disabled={loading} // Bloquea el botón cuando loading es true
                    >
                      {loading ? "Guardando..." : "Finalizar"}
                    </Button>
                  ))}
              </div>
            </Form>
          </div>
        </div>
      </Modal>

      {/* Modal de advertencia */}
      <Modal
        title="Advertencia: Presupuesto excedido"
        open={isModalVisible} // Controla la visibilidad del modal
        onOk={handleCloseModal}
        onCancel={handleCloseModal}
        okText="Entendido"
        cancelText="Cerrar"
      >
        <p>El valor proyectado no puede ser mayor que el valor asignado.</p>
        <p>
          <strong>Valor asignado:</strong>{" "}
          {presupuestoasignado.toLocaleString("es-CO", {
            style: "currency",
            currency: "COP",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })}
        </p>
        <p>
          <strong>Valor proyectado:</strong>{" "}
          <span style={{ color: "red" }}>
            {proyectado.toLocaleString("es-CO", {
              style: "currency",
              currency: "COP",
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            })}
          </span>
        </p>
        <p>
          <strong>Exceso:</strong>{" "}
          <span style={{ color: "red" }}>
            {(proyectado - presupuestoasignado).toLocaleString("es-CO", {
              style: "currency",
              currency: "COP",
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            })}
          </span>
        </p>
      </Modal>

      {/* Modal para mostrar detalles del producto */}
      <Modal
        title={
          <span style={{ fontWeight: "bold", fontSize: "18px" }}>
            🛒 Detalles del Producto
          </span>
        }
        open={isModalVisibleP}
        onCancel={handleCloseModalP}
        width="60%"
        footer={[
          <Button key="close" type="primary" onClick={handleCloseModalP}>
            Cerrar
          </Button>,
        ]}
      >
        {selectedProductDetails && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              fontSize: "16px",
            }}
          >
            {/* Producto */}
            <div>
              <Tag color="blue">Producto: </Tag>
              <span style={{ fontWeight: "bold" }}>
                {" "}
                {selectedProductDetails.nombre_producto}
              </span>
            </div>

            {/* Descripción */}
            <div>
              <Tag color="green">Descripción:</Tag>
              <span> {selectedProductDetails.descripcion_producto}</span>
            </div>

            {/* Precio COP */}
            <div>
              <Tag color="gold">Precio de referencia COP: </Tag>
              <span style={{ fontWeight: "bold", color: "#198754" }}>
                {new Intl.NumberFormat("es-CO", {
                  style: "currency",
                  currency: "COP",
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }).format(selectedProductDetails.precio_unitarioPesos)}
              </span>
            </div>

            {/* Unidad de medida */}
            <div>
              <Tag color="red">Unidad de medida: </Tag>
              <span> {selectedProductDetails.nombreUnidadMedida}</span>
            </div>

            {/* Tipo */}
            <div>
              <Tag color="cyan">Categoría:</Tag>
              <span> {selectedProductDetails.nombreCategoria}</span>
            </div>
          </div>
        )}
      </Modal>

      {/* Modal para mostrar detalles del plan de compras */}
      <Modal
        title={
          <span style={{ fontWeight: "bold", fontSize: "18px" }}>
            📄 Detalles del Plan de Compras
          </span>
        }
        open={isModalPreviewOpen}
        onCancel={handleClosePreview}
        width="50%"
        style={{ top: 20 }}
        footer={[
          <Button key="close" type="primary" onClick={handleClosePreview}>
            Cerrar
          </Button>,
        ]}
      >
        {selectedPlan && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              fontSize: "16px",
            }}
          >
            {/* Usuario */}
            <div>
              <Tag color="blue">Usuario: </Tag>
              <span style={{ fontWeight: "bold" }}>{selectedPlan.user}</span>
            </div>

            {/* Código codigoInterno */}
            <div>
              <Tag color="green">Código Interno:</Tag>
              <span>{selectedPlan.codigoInterno}</span>
            </div>

            {/* Fecha de Creación */}
            <div>
              <Tag color="gold">Fecha de Creación:</Tag>
              <span>
                {new Date(selectedPlan.fecha_creacion).toLocaleString("es-CO")}
              </span>
            </div>

            {/* Última Actualización */}
            <div>
              <Tag color="purple">Última Actualización:</Tag>
              <span>
                {new Date(selectedPlan.fecha_actualizacion).toLocaleString(
                  "es-CO"
                )}
              </span>
            </div>

            {/* Conceptos de Inversión */}
            <div>
              <h4>Conceptos de Inversión</h4>
              <Table
                dataSource={selectedPlan.conceptoInversion}
                pagination={false}
                rowKey="concepto"
                columns={[
                  { title: "Concepto", dataIndex: "concepto", key: "concepto" },
                  {
                    title: "Valor",
                    dataIndex: "valor",
                    key: "valor",
                    align: "right",
                    render: (value) =>
                      value.toLocaleString("es-CO", {
                        style: "currency",
                        currency: "COP",
                      }),
                  },
                  {
                    title: "% del Total",
                    dataIndex: "porcentaje",
                    key: "porcentaje",
                    align: "center",
                  },
                ]}
                bordered
                size="small"
              />
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default PlanesCompras;
